<template>
  <section id="mainContent">
    <!-- HEADER -->
    <leftMenu v-if="!isLoading"
      :userInfo="userInfo"
      @menus="value => menus = value"
      @manager-data="v => managerData = v"
      @module-pd="v => modulePersonalDevelopment = v"
      @pdi-access="v => pdiAccess = v"
      @user-in-pause="v => pauseData = v"
      :openModalByHome="openModalByHome"
    />

    <new-header v-if="!isLoading" :userInfo="userInfo" :showMood="showMood" :notification-reminder="hasReminders"></new-header>

    <confirmation-modal
      :titleIcon="['clipboard-outline', 'pencil']"
      :title="$t('Assinatura')"
      :cancelButtonText="$t('Fechar')"
      @close-modal="v => handleCloseModal(v)"
      v-if="isModalOpened"
      :canClose="true"
    >
      <div class="content-modal-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="58" viewBox="0 0 59 58" fill="none">
          <path d="M38.8955 7.25006H42.5205C43.9626 7.25006 45.3456 7.82294 46.3654 8.84267C47.3851 9.86239 47.958 11.2454 47.958 12.6876V48.9375C47.958 50.3796 47.3851 51.7627 46.3654 52.7824C45.3456 53.8021 43.9626 54.375 42.5205 54.375H17.1455C15.7034 54.375 14.3203 53.8021 13.3006 52.7824C12.2809 51.7627 11.708 50.3796 11.708 48.9375V12.6876C11.708 11.2454 12.2809 9.86239 13.3006 8.84267C14.3203 7.82294 15.7034 7.25006 17.1455 7.25006H20.7705" stroke="#FF445D" stroke-width="3" stroke-linejoin="round"/>
          <path d="M35.9355 3.62506H23.7305C22.0958 3.62506 20.7705 4.95031 20.7705 6.5851V7.91502C20.7705 9.5498 22.0958 10.8751 23.7305 10.8751H35.9355C37.5702 10.8751 38.8955 9.5498 38.8955 7.91502V6.5851C38.8955 4.95031 37.5702 3.62506 35.9355 3.62506Z" stroke="#FF445D" stroke-width="3" stroke-linejoin="round"/>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 35 32" fill="none" id="pencil-icon">
          <path d="M24.5312 8.01608L6.54865 24.7553L5.45898 27.2048L8.09692 26.1929L26.1237 9.49487L24.5312 8.01608ZM28.1293 4.67561L27.3502 5.39843L28.9427 6.87723L29.7218 6.15378C29.9262 5.96382 30.0411 5.70626 30.0411 5.4377C30.0411 5.16915 29.9262 4.91159 29.7218 4.72163L29.6723 4.67561C29.571 4.58152 29.4507 4.50689 29.3183 4.45597C29.1859 4.40505 29.044 4.37885 28.9008 4.37885C28.7575 4.37885 28.6156 4.40505 28.4832 4.45597C28.3509 4.50689 28.2306 4.58152 28.1293 4.67561Z" stroke="#FF445D" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span id="modal-content-bold">{{$t("Você tem assinaturas pendentes.")}}</span>
        <span>{{$t("Para regulariza-las baixe o aplicativo da MarQ. e faça as solicitações.")}}</span>
        <div class="redirect-wrapper">
          <a href="https://play.google.com/store/apps/details?id=br.com.marqponto&pli=1" target="_blank">
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.21875 2.44002V18.5592C2.21886 18.5941 2.22929 18.6283 2.24873 18.6574C2.26818 18.6864 2.29577 18.7091 2.32806 18.7226C2.36034 18.736 2.39587 18.7396 2.4302 18.733C2.46453 18.7263 2.49613 18.7096 2.52104 18.6851L10.9141 10.5L2.52104 2.3141C2.49613 2.28955 2.46453 2.27289 2.4302 2.26623C2.39587 2.25956 2.36034 2.26318 2.32806 2.27663C2.29577 2.29007 2.26818 2.31275 2.24873 2.34182C2.22929 2.37089 2.21886 2.40505 2.21875 2.44002ZM14.4332 7.13672L3.90941 1.33875L3.90285 1.33506C3.72156 1.23662 3.5493 1.48189 3.69777 1.62463L11.9472 9.51275L14.4332 7.13672ZM3.69859 19.3754C3.5493 19.5181 3.72156 19.7634 3.90367 19.6649L3.91023 19.6612L14.4332 13.8633L11.9472 11.4864L3.69859 19.3754ZM18.6816 9.47461L15.7428 7.85613L12.9796 10.5L15.7428 13.1426L18.6816 11.5254C19.481 11.0837 19.481 9.91635 18.6816 9.47461Z" fill="var(--darkBlue)"/>
            </svg>
          </a>
          <a href="https://apps.apple.com/br/app/marqponto-controle-de-ponto/id1379890385" target="_blank">
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.5696 5.6134C12.9158 5.6134 12.2169 6.40254 11.0652 6.40254C9.88437 6.40254 8.98367 5.61915 7.55058 5.61915C6.14785 5.61915 4.65201 6.47555 3.70208 7.93448C2.36826 9.99182 2.59466 13.8666 4.75496 17.1675C5.52769 18.3492 6.55964 19.6744 7.91316 19.6887H7.93777C9.1141 19.6887 9.46355 18.9185 11.0824 18.9094H11.107C12.7017 18.9094 13.0217 19.6842 14.1931 19.6842H14.2177C15.5712 19.6699 16.6585 18.2015 17.4312 17.0244C17.9874 16.1778 18.1941 15.7529 18.6207 14.7952C15.4957 13.609 14.9937 9.17889 18.0842 7.48043C17.1409 6.29918 15.8152 5.61504 14.5655 5.61504L14.5696 5.6134Z" fill="var(--darkBlue)"/>
              <path d="M14.2058 1.3125C13.2214 1.37936 12.0729 2.00607 11.4003 2.82434C10.79 3.5659 10.2879 4.66594 10.4848 5.73275H10.5636C11.6119 5.73275 12.6849 5.10152 13.3116 4.2927C13.9154 3.52283 14.3731 2.43182 14.2058 1.3125Z" fill="var(--darkBlue)"/>
            </svg>
          </a>
        </div>

        <span class="footer-modal">{{$t("Baixe agora.")}}</span>
      </div>
    </confirmation-modal>

    <confirmation-modal
      :titleIcon="['document-outline']"
      :title="$t('Admissão')"
      :cancelButtonText="$t('Fechar')"
      @close-modal="v => handleAdmissionModal(v)"
      v-if="isAdmissionModalOpened"
      :canClose="true"
    >
      <div class="content-modal-wrapper">
        <svg width="63" height="62" viewBox="0 0 63 62" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M50.625 26.792V50.375C50.625 51.9166 50.0126 53.395 48.9226 54.4851C47.8325 55.5751 46.3541 56.1875 44.8125 56.1875H17.6875C16.1459 56.1875 14.6675 55.5751 13.5774 54.4851C12.4874 53.395 11.875 51.9166 11.875 50.375V11.625C11.875 10.0834 12.4874 8.605 13.5774 7.51494C14.6675 6.42489 16.1459 5.8125 17.6875 5.8125H29.6455C30.6729 5.81266 31.6581 6.22078 32.3846 6.94715L49.4904 24.0529C50.2167 24.7794 50.6248 25.7646 50.625 26.792Z" stroke="var(--darkBlue)" stroke-width="3" stroke-linejoin="round"/>
          <path d="M31.25 6.78125V21.3125C31.25 22.3402 31.6583 23.3258 32.385 24.0525C33.1117 24.7792 34.0973 25.1875 35.125 25.1875H49.6562" stroke="var(--darkBlue)" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span id="modal-content-bold">{{$t("Você tem uma admissão online em aberto.")}}</span>
        <span>{{$t("Para regulariza-la baixe o aplicativo da MarQ. e faça as solicitações.")}}</span>

        <div class="redirect-wrapper">
          <a href="https://play.google.com/store/apps/details?id=br.com.marqponto&pli=1" target="_blank">
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.21875 2.44002V18.5592C2.21886 18.5941 2.22929 18.6283 2.24873 18.6574C2.26818 18.6864 2.29577 18.7091 2.32806 18.7226C2.36034 18.736 2.39587 18.7396 2.4302 18.733C2.46453 18.7263 2.49613 18.7096 2.52104 18.6851L10.9141 10.5L2.52104 2.3141C2.49613 2.28955 2.46453 2.27289 2.4302 2.26623C2.39587 2.25956 2.36034 2.26318 2.32806 2.27663C2.29577 2.29007 2.26818 2.31275 2.24873 2.34182C2.22929 2.37089 2.21886 2.40505 2.21875 2.44002ZM14.4332 7.13672L3.90941 1.33875L3.90285 1.33506C3.72156 1.23662 3.5493 1.48189 3.69777 1.62463L11.9472 9.51275L14.4332 7.13672ZM3.69859 19.3754C3.5493 19.5181 3.72156 19.7634 3.90367 19.6649L3.91023 19.6612L14.4332 13.8633L11.9472 11.4864L3.69859 19.3754ZM18.6816 9.47461L15.7428 7.85613L12.9796 10.5L15.7428 13.1426L18.6816 11.5254C19.481 11.0837 19.481 9.91635 18.6816 9.47461Z" fill="var(--darkBlue)"/>
            </svg>
          </a>
          <a href="https://apps.apple.com/br/app/marqponto-controle-de-ponto/id1379890385" target="_blank">
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.5696 5.6134C12.9158 5.6134 12.2169 6.40254 11.0652 6.40254C9.88437 6.40254 8.98367 5.61915 7.55058 5.61915C6.14785 5.61915 4.65201 6.47555 3.70208 7.93448C2.36826 9.99182 2.59466 13.8666 4.75496 17.1675C5.52769 18.3492 6.55964 19.6744 7.91316 19.6887H7.93777C9.1141 19.6887 9.46355 18.9185 11.0824 18.9094H11.107C12.7017 18.9094 13.0217 19.6842 14.1931 19.6842H14.2177C15.5712 19.6699 16.6585 18.2015 17.4312 17.0244C17.9874 16.1778 18.1941 15.7529 18.6207 14.7952C15.4957 13.609 14.9937 9.17889 18.0842 7.48043C17.1409 6.29918 15.8152 5.61504 14.5655 5.61504L14.5696 5.6134Z" fill="var(--darkBlue)"/>
              <path d="M14.2058 1.3125C13.2214 1.37936 12.0729 2.00607 11.4003 2.82434C10.79 3.5659 10.2879 4.66594 10.4848 5.73275H10.5636C11.6119 5.73275 12.6849 5.10152 13.3116 4.2927C13.9154 3.52283 14.3731 2.43182 14.2058 1.3125Z" fill="var(--darkBlue)"/>
            </svg>
          </a>
        </div>

        <span class="footer-modal">{{$t("Baixe agora.")}}</span>
      </div>
    </confirmation-modal>

    <!-- RETROSPECTIVE -->
    <a :href="urlRetrospective" target="_blank" v-if="showRetrospective" class="retrospective-card">
      <div class="retrospective-card-detail">
        <ion-icon name="play-back-outline"></ion-icon>
      </div>
      <div class="retrospective-card-title">
        <ion-icon name="play-back-outline"></ion-icon>
        <p>{{$t("Que tal relembrar ")}}<span>{{$t("os seus momentos")}}</span> {{$t("com a gente?")}}</p>
      </div>
      <a :href="urlRetrospective" target="_blank" class="retrospective-card-link">
        <ion-icon name="play-back-outline"></ion-icon>
        <span>{{$t("Relembrar o meu ano")}}</span>
      </a>
      <div class="retrospective-card-logo">
        <ion-icon name="play-back-outline"></ion-icon>
        <span>{{$t("Retro")}}</span>
        <img src="../../../../assets/img/logo-white.png">
      </div>
    </a>

    <!-- CONTENT -->
    <div class="home-mid-wrapper" v-if="!isLoading">
      <NewInfoBanner v-if="userInfo.role === 1 && managerData.isManager && modulePersonalDevelopment" />
      <carousel v-if="managerData.isManager" :isManager="managerData.isManager" :cards="managerData.myTeam"></carousel>
      <div class="left-column">
        <shadow-box class="onCall-card" v-if="workData.isOnCallDuty">
          <div class="title">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" class="clock-svg">
              <g opacity="0.2" clip-path="url(#clip0_146_6860)">
              <path d="M25 16H22V28L31.5 33.7L33 31.24L25 26.5V16ZM34.674 3.62L43.888 11.31L41.328 14.38L32.108 6.69399L34.674 3.62ZM13.326 3.62L15.89 6.692L6.67401 14.38L4.11401 11.308L13.326 3.62ZM24 8C14.06 8 6.00001 16.06 6.00001 26C6.00001 35.94 14.06 44 24 44C33.94 44 42 35.94 42 26C42 16.06 33.94 8 24 8ZM24 40C16.28 40 10 33.72 10 26C10 18.28 16.28 12 24 12C31.72 12 38 18.28 38 26C38 33.72 31.72 40 24 40Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_146_6860">
              <rect width="48" height="48" fill="white"/>
              </clipPath>
              </defs>
              </svg>
            <span>{{$t("Você está em regime de sobreaviso")}}</span>
          </div>

          <div class="content">
            <span>{{$t("Hora de início do regime:")}}</span>

            <div>
              <span>{{workData.onCallDutyInitDate | formatHours}}</span>
              <span>{{workData.onCallDutyInitDate | formatDate}}</span>
            </div>
          </div>

          <div class="content">
            <span>{{$t("Hora de término do regime:")}}</span>

            <div>
              <span>{{workData.onCallDutyEndDate | formatHours}}</span>
              <span>{{workData.onCallDutyEndDate | formatDate}}</span>
            </div>
          </div>
        </shadow-box>

        <shadow-box
          class="hours-remaining-home-card"
          v-if="!pauseData.userInPause"
        >
          <div class="top-hours-remaining-home-card">
            <div class="top-hours-remaining-home-card-wrapper">
              <div class="left-box">
                <div class="day-title">
                  {{ date |  strDayFull }}
                </div>
                <div class="day-content">
                  {{ date | formatDate }}
                </div>
              </div>

              <svg class="mid-line" xmlns="http://www.w3.org/2000/svg" width="2" height="73" viewBox="0 0 2 73" fill="none">
                <path d="M1 72L1 1" stroke="#F2F2F2" stroke-linecap="round"/>
              </svg>

              <div class="right-box">
                <div class="day-title">
                  {{$t("Hora:")}}
                </div>
                <div class="day-content">
                  {{ currentTime }}
                </div>
                <general-tooltip
                class="remaining-hours-tooltip"
                :content="$t('Este é o horário oficial central e pode estar diferente do horário do seu computador.')"
                @show-tooltip="handleTooltip">
                  <img
                    src="../../../../assets/img/tooltip/information-circle-outline.svg"
                    alt="$t('dica de ferramenta')"
                    @mouseover="showTooltip"
                    @mouseout="hideTooltip"
                  >
                </general-tooltip>
              </div>
            </div>
          </div>
          <div class="last-point-registered-tag">
            <p class="text-first-part"  v-if="workData.lastPointRegistered">{{$t("Último ponto registrado:")}}</p>
            <p class="text-second-part" v-if="workData.lastPointRegistered">&nbsp;{{ this.workData.lastPointRegistered}}</p>
            <p class="text-first-part" v-else>{{$t("Nenhum ponto registrado")}}</p>
          </div>
          <div class="hours-remaining" v-if="!showPointCache">
            <p v-if="!this.isEndOfJourney" class="hours-remaining-title">{{$t("Horas faltantes")}}</p>
            <div v-if="!this.isEndOfJourney" class="hours-remaining-content" :style="{'color': this.workData.userPointDayStatus !== 2 ? '#7E8DA7' : '#3A424E'}">{{ this.workData.workHoursLeft }}</div>
            <div v-if="this.isEndOfJourney" class="hours-remaining-content" :style="{'color': this.workData.userPointDayStatus !== 2 ? '#7E8DA7' : '#3A424E'}">{{$t("Jornada Completa")}}</div>

          </div>
          <div class="hours-remaining-progress-bar" v-if="!showPointCache">
            <div class="percentage-progress-bar" :style="{ width: `${this.workData.workedHoursPercentage}%` }">

            </div>

            <div class="reference-hours-wrapper">
              <div class="right-reference-hours">
                {{ this.workData.workedHours }}
              </div>

              <div class="left-reference-hours">
                {{ this.workData.workingDayTotal }}
              </div>
            </div>

            <div class="progress-status" :style="[{'color': workData.userPointDayStatus === 2 ? 'var(--darkBlue)' : '#7E8DA7' }]">
              {{ returnUserPointDayStr }}
            </div>
          </div>

          <div v-if="!showPointCache" class="see-details-button" @click="redirectToTodayDetails(todayId)" >
            {{$t("Ver detalhes de hoje")}}
          </div>

          <div class="point-cache-wrapper" v-if="showPointCache">
            <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.9349 44.4062H35.0642C36.9591 44.4062 38.4664 42.8472 38.2626 41.0509C36.9467 29.4766 29.0933 29.668 29.0933 24.5C29.0933 19.332 37.0472 19.6191 38.2616 7.9491C38.453 6.1518 36.9591 4.59375 35.0642 4.59375H13.9349C12.0399 4.59375 10.5498 6.1518 10.7374 7.9491C11.9519 19.6191 19.9058 19.2363 19.9058 24.5C19.9058 29.7637 12.0524 29.4766 10.7374 41.0509C10.5326 42.8472 12.0399 44.4062 13.9349 44.4062Z" stroke="#1B59F8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M32.8553 41.3438H16.1867C14.6937 41.3438 14.2727 39.6211 15.3196 38.553C17.8539 35.9844 22.9692 34.145 22.9692 31.1992V21.4375C22.9692 19.5378 19.3325 18.0879 17.0825 15.0063C16.7112 14.4981 16.7485 13.7812 17.6921 13.7812H31.3518C32.1567 13.7812 32.3309 14.4923 31.9643 15.0015C29.7469 18.0879 26.0317 19.5282 26.0317 21.4375V31.1992C26.0317 34.121 31.3633 35.6973 33.7262 38.5559C34.6785 39.7082 34.3454 41.3438 32.8553 41.3438Z" fill="#1B59F8" fill-opacity="0.4"/>
            </svg>

            <span>{{$t("Ponto em processamento")}}</span>
            <span>{{$t("Seu ponto das")}}<span>{{ this.workData.lastPointRegistered.split(" ")[1] }}</span>{{$t("já foi registrado!")}}</span>
            <span>{{$t("Atualize a página para visualizar o ponto.")}}</span>

            <button @click="reloadPage()">
              <ion-icon name="refresh"></ion-icon>
              {{$t("Atualizar página")}}
            </button>
          </div>
        </shadow-box>

        <shadow-box class="pause-home-card" v-else>
          <img src="../../../../assets/img/home/pause-circle-outline-big.png" class="bg-img-top">
          <img src="../../../../assets/img/home/pause-circle-outline-small.png" class="bg-img-bottom">
          <div class="top-pause-home-card">
            <div class="top-pause-home-card-wrapper">
              <div class="left-box">
                <div class="day-title">
                  {{ date |  strDayFull }}
                </div>
                <div class="day-content">
                  {{ date | formatDate }}
                </div>
              </div>

              <svg class="pause-mid-line" xmlns="http://www.w3.org/2000/svg" width="2" height="73" viewBox="0 0 2 73" fill="none">
                <path d="M1 72L1 1" stroke="#fff" stroke-linecap="round"/>
              </svg>

              <div class="right-box">
                <div class="day-title">
                  {{$t("Hora:")}}
                </div>
                <div class="day-content">
                  {{ currentTime }}
                </div>
                <general-tooltip
                class="remaining-hours-tooltip"
                :content="$t('Este é o horário oficial central e pode estar diferente do horário do seu computador.')"
                @show-tooltip="handleTooltip">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
                  alt="$t('dica de ferramenta')"
                    @mouseover="showTooltip"
                    @mouseout="hideTooltip"
                  >
                    <path d="M7.2749 7.05681H8.2749V10.6818" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6.8999 10.8068H9.6499" stroke="#fff" stroke-miterlimit="10" stroke-linecap="round"/>
                    <path d="M8.1499 4.24431C7.98921 4.24431 7.83212 4.29196 7.6985 4.38124C7.56489 4.47052 7.46075 4.59741 7.39925 4.74588C7.33775 4.89434 7.32166 5.05771 7.35301 5.21532C7.38437 5.37293 7.46175 5.5177 7.57538 5.63133C7.68901 5.74496 7.83378 5.82235 7.99139 5.8537C8.149 5.88505 8.31237 5.86896 8.46083 5.80746C8.6093 5.74596 8.73619 5.64182 8.82547 5.50821C8.91475 5.37459 8.9624 5.21751 8.9624 5.05681C8.9624 4.84132 8.8768 4.63466 8.72443 4.48228C8.57205 4.32991 8.36539 4.24431 8.1499 4.24431Z" fill="#fff"/>
                    <path d="M8.1499 2.18181C4.97459 2.18181 2.3999 4.7565 2.3999 7.93181C2.3999 11.1071 4.97459 13.6818 8.1499 13.6818C11.3252 13.6818 13.8999 11.1071 13.8999 7.93181C13.8999 4.7565 11.3252 2.18181 8.1499 2.18181Z" stroke="#fff" stroke-miterlimit="10"/>
                  </svg>

                </general-tooltip>
              </div>
            </div>
          </div>
          <div class="last-pause-registered-tag">
            <p class="text-first-part">{{$t("Pausa iniciada em:")}}</p>
            <p class="text-second-part">&nbsp;{{ pauseData.pauseDateText }}</p>
          </div>

          <div class="pause-text">
            {{$t("Você está em")}}<span>&nbsp;{{$t("pausa")}}</span>
          </div>

          <div class="pause-title">
            {{ pauseData.pauseTitle }}
          </div>
          <div class="pause-progress-bar">
            <div class="percentage-progress-bar" :style="{ width: `${this.pauseData.pausedTimePercentage}%` }">

            </div>

            <div class="reference-hours-wrapper">
              <div class="right-reference-hours">
                {{ this.pauseData.pausedTime }}
              </div>

              <div class="left-reference-hours">
                {{ pauseData.totalPauseTime }}
              </div>
            </div>
          </div>

          <button class="button-return-pause" @click="openModalByHome = !openModalByHome">
              <ion-icon name="play-circle-outline"></ion-icon>
              <div>{{$t("Voltar da pausa")}}</div>
          </button>
        </shadow-box>

        <div v-if="pauseData.userInPause" class="background-pause"></div>

        <shadow-box class="hours-balance-card" @click.native="redirectToHoursBalance()" v-if="canSeeHoursBalance">
          <div class="top-hours-balance-card-wrapper">
            <svg class="mid-line-hours-balance" xmlns="http://www.w3.org/2000/svg" width="2" height="73" viewBox="0 0 2 73" fill="none">
              <path d="M1 72L1 1" stroke="#F2F2F2" stroke-linecap="round"/>
            </svg>

            <div class="hours-balance-left-box" >
              <div class="hours-balance-title">
                {{$t("Saldo de horas")}}

                <general-tooltip
                class="balance-hours-tooltip"
                :content="$t('Em caso de dúvidas sobre seu saldo, entre em contato com seu RH ou Gestor.')"
                  @show-tooltip="handleTooltip">
                  <img
                  src="../../../../assets/img/tooltip/information-circle-outline.svg"
                  alt="$t('dica de ferramenta')"
                  @mouseover="showTooltip"
                  @mouseout="hideTooltip"
                >
                </general-tooltip>
              </div>
              <div class="hours-balance-content">
                {{$t("Saldo acumulado desde")}} {{ workData.hoursBalanceStartDate }}
              </div>
            </div>

            <div class="hours-balance-right-box" :style="[{'color': workData.isBalanceNegative === false ? '#2ACC6B' : '#FF445D' }]">
             <div v-if="workData.isBalanceNegative === false">+</div>
             <div v-else>-</div>

              {{ workData.totalHoursBalance }}
            </div>
          </div>
        </shadow-box>

        <shadow-box
          class="home-advice-wrapper"
          :icon="firstResult.icons"
          :style="[
            { 'color': (firstResult.type === 2 || firstResult.type === 7) ? '#FF445D' : (firstResult.type === 6 || firstResult.type === 8) ? '#FF9900' : '#1B59F8'},
          ]"
          v-if="firstResult && firstResult.content && !canSeeHoursBalance"
          @click.native="redirectTo(firstResult.page, firstResult.id, firstResult.type)"
        >
          <div class="home-advice-left-box">
            <div class="home-advice-type-title"
            :style="[
              { 'color': (firstResult.type === 2 || firstResult.type === 7) ? '#FF445D' : (firstResult.type === 6 || firstResult.type === 8) ? '#FF9900' : '#1B59F8'}
            ]"
            >
             {{ firstResult.cardTitle }}
            </div>
            <div class="home-advice-title-statement-content" v-if="firstResult.type === 1">
              {{ firstResult.content.title | limitTo(22) }}
              <div class="home-advice-content" :style="{'left': '0 !important'}">
                {{$t("Não lido")}} | {{ firstResult.content.createdAt | formatDate }}
              </div>
            </div>
            <div class="home-advice-content">
              {{ firstResult.content.message }}
            </div>

          </div>

          <div class="home-advice-right-box">
            {{$t("Detalhes")}}
          </div>
        </shadow-box>

        <shadow-box
          class="home-advice-wrapper"
          :icon="secondResult.icons"
          :style="[
            { 'color': (secondResult.type === 2 || secondResult.type === 7) ? '#FF445D' : (secondResult.type === 6 || secondResult.type === 8) ? '#FF9900' : '#1B59F8'},
          ]"
          v-if="secondResult && secondResult.content && !canSeeHoursBalance"
          @click.native="redirectTo(secondResult.page, secondResult.id, secondResult.type)"
        >
          <div class="home-advice-left-box">
            <div class="home-advice-type-title"
            :style="[
              { 'color': (secondResult.type === 2 || secondResult.type === 7) ? '#FF445D' : (secondResult.type === 6 || secondResult.type === 8) ? '#FF9900' : '#1B59F8'}
            ]"
            >
             {{ secondResult.cardTitle }}
            </div>
            <div class="home-advice-title-statement-content" v-if="secondResult.type === 1">
              {{ secondResult.content.title | limitTo(22) }}
              <div class="home-advice-content" :style="{'left': '0 !important'}">
                {{$t("Não lido")}} | {{ secondResult.content.createdAt | formatDate }}
              </div>
            </div>
            <div class="home-advice-content" v-else-if="secondResult.content.message">
              {{ secondResult.content.message }}
            </div>

          </div>

          <div class="home-advice-right-box">
            {{$t("Detalhes")}}
          </div>
        </shadow-box>

        <shadow-box
          class="home-advice-wrapper"
          :icon="['people-outline']"
          :style="[
            { 'color': '#1B59F8'},
          ]"
          v-if="hasMeetings"
          @click.native="redirectToV2Function('pt', 'reunioes')"
        >
          <div class="home-advice-left-box">
            <div class="home-advice-type-title"
                 :style="[
              { 'color': '#1B59F8'}
            ]"
            >
              {{$t("Reuniões 1:1")}}
            </div>
            <div class="home-advice-content" :style="{'width': '33ch'}">
              {{$t("Confira suas reuniões 1:1 agendadas, após o término, não se esqueça de avaliá-las.")}}
            </div>

          </div>

          <div class="home-advice-right-box">
            {{$t("Detalhes")}}
          </div>
        </shadow-box>

        <shadow-box
          class="home-advice-wrapper"
          :icon="['document-text-outline']"
          :style="[
            { 'color': '#1B59F8'},
          ]"
          v-if="hasReminders"
          @click.native="redirectToV2Function('pt', 'lembretes')"
        >
          <div class="home-advice-left-box">
            <div class="home-advice-type-title"
                 :style="[
              { 'color': '#1B59F8'}
            ]"
            >
              {{$t("Novo lembrete")}}
            </div>
            <div class="home-advice-content" :style="{'width': '33ch'}">
              {{$t("Você tem um novo lembrete, clique aqui para ver os detalhes.")}}
            </div>

          </div>

          <div class="home-advice-right-box">
            {{$t("Detalhes")}}
          </div>
        </shadow-box>

        <shadow-box
          class="home-advice-wrapper"
          :icon="['alert-circle-outline']"
          :style="[
            { 'color': '#FF9900'},
          ]"
          v-if="hasTask"
          @click.native="redirectToV2Function('pt', 'task-management')"
        >
          <div class="home-advice-left-box">
            <div class="home-advice-type-title"
                 :style="[
              { 'color': '#FF9900'}
            ]"
            >
              {{$t("Tarefas pendentes")}}
            </div>
            <div class="home-advice-content" :style="{'width': '33ch'}">
              {{$t("Você tem tarefas pendentes em seu nome, clique aqui para ver os detalhes")}}
            </div>

          </div>

          <div class="home-advice-right-box">
            {{$t("Detalhes")}}
          </div>
        </shadow-box>

        <shadow-box
          class="home-advice-wrapper"
          :icon="firstResult.icons"
          :style="[
            { 'color': (firstResult.type === 2 || firstResult.type === 7) ? '#FF445D' : (firstResult.type === 6 || firstResult.type === 8) ? '#FF9900' : '#1B59F8'},
          ]"
          v-if="firstResult && firstResult.content && canSeeHoursBalance"
          @click.native="redirectTo(firstResult.page, firstResult.id, firstResult.type)"
        >
          <div class="home-advice-left-box">
            <div class="home-advice-type-title"
            :style="[
              { 'color': (firstResult.type === 2 || firstResult.type === 7) ? '#FF445D' : (firstResult.type === 6 || firstResult.type === 8) ? '#FF9900' : '#1B59F8'}
            ]"
            >
             {{ firstResult.cardTitle }}
            </div>
            <div class="home-advice-title-statement-content" v-if="firstResult.type === 1">
              {{ firstResult.content.title | limitTo(22) }}
              <div class="home-advice-content" :style="{'left': '0 !important'}">
                {{$t("Não lido")}} | {{ firstResult.content.createdAt | formatDate }}
              </div>
            </div>
            <div class="home-advice-content" v-else-if="firstResult.content.message">
              {{ firstResult.content.message }}
            </div>

          </div>

          <div class="home-advice-right-box">
            {{$t("Detalhes")}}
          </div>
        </shadow-box>
      </div>

      <div class="mid-column">
        <shadow-box class="last-ten-days-home-card">
          <div class="first-line-last-ten-days-home-card">
            <div class="left-box-first-line-last-ten-days-home-card">
              {{$t("Últimos 10 dias")}}

              <general-tooltip
                class="last-ten-days-tooltip"
                :title="$t('Assinatura')"

                :content="`${$t('Em caso de dúvidas sobre seu saldo, entre em contato com seu RH ou Gestor. Última atualização do histórico de dias foi feita no dia')} ${this.lastAttFromDays.split(/(\s)/)[0]} às ${this.lastAttFromDays.split(/(\s)/)[2]}.`"
                @show-tooltip="handleTooltip"
                @click.native="getMainHome"
              >
                <img
                src="../../../../assets/img/tooltip/information-circle-outline.svg"
                alt="dica de ferramenta"
                @mouseover="showTooltip"
                @mouseout="hideTooltip"
                >
              </general-tooltip>
            </div>

            <a class="right-box-first-line-last-ten-days-home-card" href="/historico-de-ponto">
                {{$t("Ver histórico")}}
            </a>

            <div class="bottom-border-first-line-last-ten-days-home-card"></div>
          </div>
          <div class="table-last-ten-days-home-card">
            <div class="table-header-last-ten-days-home-card">
              <div id="first-col">{{$t("Data")}}</div>
              <div id="second-col">{{$t("Trabalhado")}}</div>
              <div id="third-col">{{$t("Saldo")}}</div>
              <div id="fourth-col">{{$t("Status")}}</div>
              <div class="bottom-border-table-header-last-ten-days-home-card"></div>
            </div>

            <div class="table-content-last-ten-days-home-card">
              <div class="table-content-last-ten-days-home-card-full" v-if="this.points">
                <div class="content-line" v-for="point, index in points.slice(0, 10)"
                :key="index"
                @click="redirectToDayDetails(point.id)"
                >
                  <div class="date-box-home-table">
                    {{ point.dateFull | formatDate }}

                    <p class="date-name">{{ point.dateFull | strDayFull }}</p>
                  </div>

                  <div class="worked-hours-home-table">
                    {{ point.workedHours }}
                  </div>

                  <div class="balance-hours-home-table" :style="[{'color': point.dayBalance === '00:00' ? '#7E8DA7' : point.isPositive ? '#2AC166' : '#FF445D'}]">
                    {{ point.signal }} {{ point.dayBalance }}
                  </div>

                  <div class="status-home-table">
                    <status
                      :data="checkLastTenDaysStatus(point.userPointDayStatus, point.userPointAdjustmentStatus, point.userVacationType)"
                      >
                    </status>
                  </div>
                </div>
              </div>

              <div class="table-content-last-ten-days-home-card-empty" v-else>
                <svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47" fill="none">
                  <path d="M5.80895 18.543C5.56127 18.5452 5.3174 18.4819 5.10212 18.3594C4.94421 18.2706 4.80559 18.1513 4.69437 18.0083C4.58315 17.8653 4.50156 17.7016 4.45438 17.5267C4.40719 17.3518 4.39536 17.1693 4.41957 16.9897C4.44379 16.8102 4.50356 16.6373 4.5954 16.4812C6.36524 13.5272 11.75 6.63232 23.5 6.63232C28.592 6.63232 33.0579 7.9698 36.7674 10.6062C39.8206 12.7699 41.5317 15.219 42.3469 16.3986C42.4502 16.5473 42.5228 16.7151 42.5604 16.8923C42.5979 17.0695 42.5996 17.2524 42.5654 17.4302C42.5312 17.608 42.4617 17.7772 42.3611 17.9278C42.2606 18.0784 42.1309 18.2073 41.9797 18.307C41.6707 18.5113 41.2943 18.5872 40.9304 18.5186C40.5664 18.4501 40.2434 18.2425 40.0299 17.9399C38.5547 15.8184 34.0567 9.36328 23.5 9.36328C13.1958 9.36328 8.53716 15.3035 7.01975 17.8508C6.89783 18.0635 6.72132 18.2399 6.50847 18.3615C6.29561 18.4832 6.05412 18.5458 5.80895 18.543Z" fill="#E2E9F1"/>
                  <path d="M29.42 45.5313C29.3029 45.5327 29.186 45.5194 29.0721 45.4918C20.5488 43.3805 17.3662 34.8599 17.2367 34.5056L17.2165 34.4275C17.1468 34.1815 15.4366 28.3386 18.062 24.9165C19.2655 23.3559 21.0959 22.5554 23.5129 22.5554C25.7601 22.5554 27.3812 23.254 28.4956 24.6998C29.4136 25.8803 29.7808 27.3362 30.136 28.7389C30.8823 31.6599 31.4212 33.1938 34.523 33.3517C35.8853 33.4205 36.7803 32.6237 37.2879 31.9453C38.6603 30.0956 38.899 27.0801 37.8644 24.418C36.5352 20.982 31.8178 14.5039 23.5 14.5039C19.9493 14.5039 16.6869 15.645 14.0707 17.7894C11.9052 19.5656 10.1895 22.0735 9.36332 24.6512C7.83123 29.4503 9.84067 36.9942 9.85995 37.063C9.90686 37.2386 9.91815 37.4218 9.89315 37.6018C9.86814 37.7818 9.80735 37.955 9.71435 38.1111C9.62135 38.2673 9.49803 38.4032 9.35166 38.5109C9.2053 38.6186 9.03884 38.6959 8.86211 38.7383C8.50508 38.8333 8.12506 38.7846 7.8035 38.6027C7.48194 38.4208 7.24442 38.1202 7.14184 37.7653C7.05004 37.421 4.90383 29.375 6.67368 23.8287C8.60141 17.8187 14.5508 11.7601 23.5028 11.7601C27.6401 11.7601 31.5488 13.1665 34.8113 15.8221C37.3375 17.8876 39.4011 20.6617 40.4806 23.4349C41.853 26.9755 41.4849 30.9494 39.5452 33.5454C38.2527 35.2767 36.4122 36.1818 34.3734 36.0835C29.062 35.8173 28.1073 32.1097 27.4115 29.4053C26.6955 26.6312 26.2374 25.2937 23.5028 25.2937C22.001 25.2937 20.9463 25.7068 20.2899 26.5624C19.3949 27.7328 19.3251 29.5623 19.4243 30.8897C19.4893 31.8145 19.6462 32.7305 19.8924 33.6243C20.1109 34.1751 22.9557 41.1517 29.7689 42.8398C29.945 42.8815 30.111 42.9578 30.2574 43.0643C30.4037 43.1707 30.5275 43.3052 30.6214 43.4598C30.7154 43.6145 30.7776 43.7863 30.8046 43.9653C30.8316 44.1442 30.8228 44.3267 30.7786 44.5022C30.6955 44.7985 30.5177 45.0595 30.2724 45.2453C30.0271 45.4311 29.7277 45.5315 29.42 45.5313Z" fill="#E2E9F1"/>
                  <path d="M18.4796 44.9015C18.2886 44.9019 18.0994 44.8638 17.9234 44.7896C17.7474 44.7153 17.5882 44.6063 17.4552 44.4692C14.044 40.8891 12.1144 36.8858 11.3883 31.8801V31.8535C10.9808 28.5396 11.5774 23.8479 14.5012 20.6222C16.6593 18.2419 19.6932 17.032 23.5028 17.032C28.0082 17.032 31.5488 19.1268 33.7565 23.0805C35.3583 25.9528 35.6759 28.815 35.6842 28.9325C35.701 29.1137 35.6819 29.2964 35.628 29.4702C35.5741 29.6439 35.4864 29.8054 35.37 29.9452C35.2536 30.0851 35.1108 30.2006 34.9497 30.2851C34.7886 30.3697 34.6124 30.4216 34.4312 30.438C34.0656 30.4777 33.699 30.372 33.4106 30.1437C33.1223 29.9155 32.9352 29.583 32.8899 29.218C32.6481 27.5006 32.0924 25.8424 31.2504 24.3262C29.5393 21.307 26.936 19.7721 23.4927 19.7721C20.5184 19.7721 18.1914 20.6671 16.5905 22.4342C14.2827 24.9816 13.8366 28.9059 14.1533 31.5019C14.7894 35.9284 16.4904 39.4497 19.494 42.5965C19.6194 42.7269 19.7172 42.8812 19.7818 43.0502C19.8463 43.2192 19.8762 43.3994 19.8697 43.5802C19.8632 43.761 19.8204 43.9386 19.7439 44.1025C19.6673 44.2664 19.5586 44.4133 19.4242 44.5343C19.1654 44.769 18.829 44.8997 18.4796 44.9015Z" fill="#E2E9F1"/>
                  <path d="M34.1944 40.9579C31.211 40.9579 28.6746 40.1318 26.645 38.4895C22.5674 35.2041 22.1102 29.8533 22.09 29.6274C22.0613 29.2568 22.181 28.8899 22.4228 28.6075C22.6646 28.325 23.0087 28.1502 23.3793 28.1215C23.75 28.0928 24.1169 28.2125 24.3993 28.4543C24.6817 28.6961 24.8565 29.0401 24.8853 29.4108C24.8954 29.4897 25.3029 33.8666 28.4461 36.3874C30.3059 37.8726 32.7917 38.462 35.855 38.1177C36.2211 38.0733 36.5899 38.1757 36.8808 38.4024C37.1716 38.6291 37.3609 38.9618 37.4073 39.3276C37.4273 39.5084 37.4112 39.6913 37.3598 39.8657C37.3084 40.0401 37.2228 40.2026 37.1079 40.3436C36.9931 40.4846 36.8513 40.6013 36.6909 40.6869C36.5304 40.7725 36.3546 40.8253 36.1735 40.8423C35.5166 40.9189 34.8558 40.9575 34.1944 40.9579ZM36.5517 4.47877C35.3877 3.72145 31.2606 1.46875 23.5 1.46875C15.354 1.46875 11.2167 3.95736 10.3015 4.58984C10.241 4.62695 10.1845 4.67 10.1326 4.71836C10.1271 4.72366 10.12 4.7269 10.1124 4.72754C9.96624 4.85514 9.84897 5.01243 9.7684 5.18893C9.68783 5.36542 9.64581 5.55706 9.64514 5.75107C9.64765 5.93294 9.68603 6.11252 9.75806 6.27953C9.8301 6.44654 9.93439 6.5977 10.0649 6.72433C10.1955 6.85097 10.3498 6.95059 10.5189 7.01751C10.688 7.08442 10.8687 7.11729 11.0506 7.11426C11.342 7.11406 11.6265 7.02469 11.8657 6.85814C11.9052 6.82877 15.466 4.21256 23.5028 4.21256C31.5396 4.21256 35.1197 6.81959 35.1582 6.83887C35.4026 7.0201 35.6994 7.11678 36.0037 7.11426C36.1857 7.11705 36.3665 7.08387 36.5356 7.01662C36.7048 6.94937 36.859 6.84938 36.9894 6.72238C37.1198 6.59538 37.2239 6.44387 37.2956 6.27656C37.3673 6.10925 37.4052 5.92942 37.4073 5.7474C37.4073 5.47475 37.3259 5.2083 37.1735 4.98226C37.0211 4.75621 36.8045 4.58088 36.5517 4.47877Z" fill="#E2E9F1"/>
                </svg>
                <p>{{$t("Nenhum registro")}}</p>
              </div>
            </div>

          </div>
        </shadow-box>
      </div>

      <div class="right-column">
        <shadow-box class="annoucements-home-card">
          <div class="first-line-annoucements-home-card">
            <div class="left-box-first-line-annoucements-home-card">
              {{$t("Comunicados")}}

              <general-tooltip
                class="last-ten-days-tooltip"
                :content="`${$t('Última atualização dos comunicados foi feita no dia')} ${this.dateNow.split(/(\s)/)[0]} às ${this.dateNow.split(/(\s)/)[2]}`"
                @show-tooltip="handleTooltip">
                <img
                src="../../../../assets/img/tooltip/information-circle-outline.svg"
                alt="dica de ferramenta"
                @mouseover="showTooltip"
                @mouseout="hideTooltip"
                >
              </general-tooltip>
            </div>

            <a class="right-box-first-line-annoucements-home-card" href="comunicados">
              {{$t("Ver todos")}}
            </a>

          <div class="bottom-border-first-line-annoucements-home-card"></div>
          </div>

          <div class="annoucements-list-home-card" v-if="!annoucements.length || annoucements === undefined">
            <svg  xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47" fill="none">
              <path d="M33.7812 38.1746V6.60938C33.7796 6.02559 33.5469 5.4662 33.1341 5.0534C32.7213 4.6406 32.1619 4.40795 31.5781 4.40625H6.60938C6.02559 4.40795 5.4662 4.6406 5.0534 5.0534C4.6406 5.4662 4.40795 6.02559 4.40625 6.60938V38.9219C4.40916 39.8948 4.79695 40.8271 5.48493 41.5151C6.17291 42.2031 7.10518 42.5908 8.07812 42.5938H38.1875" stroke="#E2E9F1" stroke-width="1.5" stroke-linejoin="round"/>
              <path d="M38.1875 42.5938C37.0189 42.5938 35.8981 42.1295 35.0718 41.3032C34.2455 40.4769 33.7813 39.3561 33.7812 38.1875V11.75H40.3906C40.9749 11.75 41.5353 11.9821 41.9485 12.3953C42.3616 12.8084 42.5938 13.3688 42.5938 13.9531V38.1875C42.5937 39.3561 42.1295 40.4769 41.3032 41.3032C40.4769 42.1295 39.3561 42.5938 38.1875 42.5938Z" stroke="#E2E9F1" stroke-width="1.5" stroke-linejoin="round"/>
              <path d="M22.0312 11.75H27.9062M22.0312 17.625H27.9062M10.2812 23.5H27.9062M10.2812 29.375H27.9062M10.2812 35.25H27.9062" stroke="#E2E9F1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16.1562 19.0938H10.2812C9.89171 19.0938 9.51813 18.939 9.24269 18.6636C8.96724 18.3881 8.8125 18.0145 8.8125 17.625V11.75C8.8125 11.3605 8.96724 10.9869 9.24269 10.7114C9.51813 10.436 9.89171 10.2812 10.2812 10.2812H16.1562C16.5458 10.2812 16.9194 10.436 17.1948 10.7114C17.4703 10.9869 17.625 11.3605 17.625 11.75V17.625C17.625 18.0145 17.4703 18.3881 17.1948 18.6636C16.9194 18.939 16.5458 19.0938 16.1562 19.0938Z" fill="#E2E9F1"/>
            </svg>
            <p>{{$t("Nenhum comunicado")}}</p>
          </div>
          <annoucements-cards v-else class="annoucements-list-home" :annoucements="annoucements"></annoucements-cards>
        </shadow-box>
      </div>

      <div v-if="pdiAccess" class="mid-column">
        <shadow-box class="last-ten-days-home-card">
          <div class="first-line-last-ten-days-home-card">
            <div class="left-box-first-line-last-ten-days-home-card">
              {{$t("PDI")}}
            </div>

            <span class="right-box-first-line-last-ten-days-home-card" style="cursor: pointer" @click="redirectToV2Function('pt','pdi')">
                {{$t("Ver todos")}}
            </span>

            <div class="bottom-border-first-line-last-ten-days-home-card"></div>
          </div>
          <div class="table-last-ten-days-home-card">
            <!-- PDI Progress Summary Card -->
            <div class="pdi-progress-content" v-if="PDIData && PDIData.name">
              <div class="pdi-progress-header">Progresso do plano</div>
              <div class="pdi-progress-percentage">{{ Math.round(PDIData.progress) }}%</div>
              <div class="pdi-progress-bar">
                <div class="pdi-progress-fill" :style="{ width: PDIData.progress + '%' }"></div>
              </div>
            </div>

            <!-- Table Headers -->
            <div class="table-header-last-ten-days-home-card" v-if="PDIData && PDIData.objectives && PDIData.objectives.length > 0">
              <div id="first-col">{{$t("Título")}}</div>
              <div id="second-col">{{$t("Progresso")}}</div>
              <div class="bottom-border-table-header-last-ten-days-home-card"></div>
            </div>

            <!-- Table Content with Objectives -->
            <div class="table-content-last-ten-days-home-card">
              <div class="table-content-last-ten-days-home-card-full" v-if="PDIData && PDIData.objectives && PDIData.objectives.length > 0">
                <div class="content-line pdi-objective-line" v-for="objective, index in PDIData.objectives"
                :key="index"
                >
                  <div class="objective-title-box">
                    {{ limitObjectiveTitle(objective.name) }}
                  </div>

                  <div class="objective-progress-box">
                    <div class="objective-progress-bar">
                      <div class="objective-progress-fill" :style="{
                        width: objective.progress + '%',
                        backgroundColor: objective.progress >= 100 ? '#12b937' : '#1B59F8'
                      }"></div>
                    </div>
                    <span class="objective-progress-text" :style="{
                      color: objective.progress >= 100 ? '#12b937' : '#1B59F8'
                    }">{{ Math.round(objective.progress) }}%</span>
                  </div>
                </div>
              </div>

              <div class="table-content-last-ten-days-home-card-empty" v-else>
                <svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47" fill="none">
                  <path d="M5.80895 18.543C5.56127 18.5452 5.3174 18.4819 5.10212 18.3594C4.94421 18.2706 4.80559 18.1513 4.69437 18.0083C4.58315 17.8653 4.50156 17.7016 4.45438 17.5267C4.40719 17.3518 4.39536 17.1693 4.41957 16.9897C4.44379 16.8102 4.50356 16.6373 4.5954 16.4812C6.36524 13.5272 11.75 6.63232 23.5 6.63232C28.592 6.63232 33.0579 7.9698 36.7674 10.6062C39.8206 12.7699 41.5317 15.219 42.3469 16.3986C42.4502 16.5473 42.5228 16.7151 42.5604 16.8923C42.5979 17.0695 42.5996 17.2524 42.5654 17.4302C42.5312 17.608 42.4617 17.7772 42.3611 17.9278C42.2606 18.0784 42.1309 18.2073 41.9797 18.307C41.6707 18.5113 41.2943 18.5872 40.9304 18.5186C40.5664 18.4501 40.2434 18.2425 40.0299 17.9399C38.5547 15.8184 34.0567 9.36328 23.5 9.36328C13.1958 9.36328 8.53716 15.3035 7.01975 17.8508C6.89783 18.0635 6.72132 18.2399 6.50847 18.3615C6.29561 18.4832 6.05412 18.5458 5.80895 18.543Z" fill="#E2E9F1"/>
                  <path d="M29.42 45.5313C29.3029 45.5327 29.186 45.5194 29.0721 45.4918C20.5488 43.3805 17.3662 34.8599 17.2367 34.5056L17.2165 34.4275C17.1468 34.1815 15.4366 28.3386 18.062 24.9165C19.2655 23.3559 21.0959 22.5554 23.5129 22.5554C25.7601 22.5554 27.3812 23.254 28.4956 24.6998C29.4136 25.8803 29.7808 27.3362 30.136 28.7389C30.8823 31.6599 31.4212 33.1938 34.523 33.3517C35.8853 33.4205 36.7803 32.6237 37.2879 31.9453C38.6603 30.0956 38.899 27.0801 37.8644 24.418C36.5352 20.982 31.8178 14.5039 23.5 14.5039C19.9493 14.5039 16.6869 15.645 14.0707 17.7894C11.9052 19.5656 10.1895 22.0735 9.36332 24.6512C7.83123 29.4503 9.84067 36.9942 9.85995 37.063C9.90686 37.2386 9.91815 37.4218 9.89315 37.6018C9.86814 37.7818 9.80735 37.955 9.71435 38.1111C9.62135 38.2673 9.49803 38.4032 9.35166 38.5109C9.2053 38.6186 9.03884 38.6959 8.86211 38.7383C8.50508 38.8333 8.12506 38.7846 7.8035 38.6027C7.48194 38.4208 7.24442 38.1202 7.14184 37.7653C7.05004 37.421 4.90383 29.375 6.67368 23.8287C8.60141 17.8187 14.5508 11.7601 23.5028 11.7601C27.6401 11.7601 31.5488 13.1665 34.8113 15.8221C37.3375 17.8876 39.4011 20.6617 40.4806 23.4349C41.853 26.9755 41.4849 30.9494 39.5452 33.5454C38.2527 35.2767 36.4122 36.1818 34.3734 36.0835C29.062 35.8173 28.1073 32.1097 27.4115 29.4053C26.6955 26.6312 26.2374 25.2937 23.5028 25.2937C22.001 25.2937 20.9463 25.7068 20.2899 26.5624C19.3949 27.7328 19.3251 29.5623 19.4243 30.8897C19.4893 31.8145 19.6462 32.7305 19.8924 33.6243C20.1109 34.1751 22.9557 41.1517 29.7689 42.8398C29.945 42.8815 30.111 42.9578 30.2574 43.0643C30.4037 43.1707 30.5275 43.3052 30.6214 43.4598C30.7154 43.6145 30.7776 43.7863 30.8046 43.9653C30.8316 44.1442 30.8228 44.3267 30.7786 44.5022C30.6955 44.7985 30.5177 45.0595 30.2724 45.2453C30.0271 45.4311 29.7277 45.5315 29.42 45.5313Z" fill="#E2E9F1"/>
                  <path d="M18.4796 44.9015C18.2886 44.9019 18.0994 44.8638 17.9234 44.7896C17.7474 44.7153 17.5882 44.6063 17.4552 44.4692C14.044 40.8891 12.1144 36.8858 11.3883 31.8801V31.8535C10.9808 28.5396 11.5774 23.8479 14.5012 20.6222C16.6593 18.2419 19.6932 17.032 23.5028 17.032C28.0082 17.032 31.5488 19.1268 33.7565 23.0805C35.3583 25.9528 35.6759 28.815 35.6842 28.9325C35.701 29.1137 35.6819 29.2964 35.628 29.4702C35.5741 29.6439 35.4864 29.8054 35.37 29.9452C35.2536 30.0851 35.1108 30.2006 34.9497 30.2851C34.7886 30.3697 34.6124 30.4216 34.4312 30.438C34.0656 30.4777 33.699 30.372 33.4106 30.1437C33.1223 29.9155 32.9352 29.583 32.8899 29.218C32.6481 27.5006 32.0924 25.8424 31.2504 24.3262C29.5393 21.307 26.936 19.7721 23.4927 19.7721C20.5184 19.7721 18.1914 20.6671 16.5905 22.4342C14.2827 24.9816 13.8366 28.9059 14.1533 31.5019C14.7894 35.9284 16.4904 39.4497 19.494 42.5965C19.6194 42.7269 19.7172 42.8812 19.7818 43.0502C19.8463 43.2192 19.8762 43.3994 19.8697 43.5802C19.8632 43.761 19.8204 43.9386 19.7439 44.1025C19.6673 44.2664 19.5586 44.4133 19.4242 44.5343C19.1654 44.769 18.829 44.8997 18.4796 44.9015Z" fill="#E2E9F1"/>
                  <path d="M34.1944 40.9579C31.211 40.9579 28.6746 40.1318 26.645 38.4895C22.5674 35.2041 22.1102 29.8533 22.09 29.6274C22.0613 29.2568 22.181 28.8899 22.4228 28.6075C22.6646 28.325 23.0087 28.1502 23.3793 28.1215C23.75 28.0928 24.1169 28.2125 24.3993 28.4543C24.6817 28.6961 24.8565 29.0401 24.8853 29.4108C24.8954 29.4897 25.3029 33.8666 28.4461 36.3874C30.3059 37.8726 32.7917 38.462 35.855 38.1177C36.2211 38.0733 36.5899 38.1757 36.8808 38.4024C37.1716 38.6291 37.3609 38.9618 37.4073 39.3276C37.4273 39.5084 37.4112 39.6913 37.3598 39.8657C37.3084 40.0401 37.2228 40.2026 37.1079 40.3436C36.9931 40.4846 36.8513 40.6013 36.6909 40.6869C36.5304 40.7725 36.3546 40.8253 36.1735 40.8423C35.5166 40.9189 34.8558 40.9575 34.1944 40.9579ZM36.5517 4.47877C35.3877 3.72145 31.2606 1.46875 23.5 1.46875C15.354 1.46875 11.2167 3.95736 10.3015 4.58984C10.241 4.62695 10.1845 4.67 10.1326 4.71836C10.1271 4.72366 10.12 4.7269 10.1124 4.72754C9.96624 4.85514 9.84897 5.01243 9.7684 5.18893C9.68783 5.36542 9.64581 5.55706 9.64514 5.75107C9.64765 5.93294 9.68603 6.11252 9.75806 6.27953C9.8301 6.44654 9.93439 6.5977 10.0649 6.72433C10.1955 6.85097 10.3498 6.95059 10.5189 7.01751C10.688 7.08442 10.8687 7.11729 11.0506 7.11426C11.342 7.11406 11.6265 7.02469 11.8657 6.85814C11.9052 6.82877 15.466 4.21256 23.5028 4.21256C31.5396 4.21256 35.1197 6.81959 35.1582 6.83887C35.4026 7.0201 35.6994 7.11678 36.0037 7.11426C36.1857 7.11705 36.3665 7.08387 36.5356 7.01662C36.7048 6.94937 36.859 6.84938 36.9894 6.72238C37.1198 6.59538 37.2239 6.44387 37.2956 6.27656C37.3673 6.10925 37.4052 5.92942 37.4073 5.7474C37.4073 5.47475 37.3259 5.2083 37.1735 4.98226C37.0211 4.75621 36.8045 4.58088 36.5517 4.47877Z" fill="#E2E9F1"/>
                </svg>
                <p>{{$t("Nenhum registro")}}</p>
              </div>
            </div>
          </div>
        </shadow-box>
      </div>

      <div class="bottom-row" v-if="requestedAdvices.length > 0">
        <shadow-box
          @click.native="redirectTo(advice.page, advice.id, advice.type)"
          v-for="advice in requestedAdvices"
          :key="advice.type"
          :icon="advice.icons"
          class="home-advice-wrapper"

          :style="[
            { 'color': (advice.type === 2 || advice.type === 7) ? '#FF445D' : (advice.type === 6 || advice.type === 8) ? '#FF9900' : '#1B59F8'},
          ]"
        >

          <div class="home-advice-left-box">
            <div class="home-advice-type-title"
            :style="[
              { 'color': (advice.type === 2 || advice.type === 7) ? '#FF445D' : (advice.type === 6 || advice.type === 8) ? '#FF9900' : '#1B59F8'}
            ]"
            >
              {{ advice.cardTitle }}
            </div>
            <div class="home-advice-title-statement-content" v-if="advice.type === 1">
              {{ advice.content.title | limitTo(22) }}
              <div class="home-advice-content" :style="{'left': '0 !important'}">
                {{$t("Não lido")}} | {{ firstResult.content.createdAt | formatDate }}
              </div>
            </div>
            <div class="home-advice-content" v-else>
              {{ advice.content.message }}
            </div>
          </div>

          <div class="home-advice-right-box">
            {{$t("Detalhes")}}
          </div>
        </shadow-box>
      </div>
    </div>

    <terms-of-use-modal
      @accept="handleAccept"
      @reject="handleReject"
      @close="termsOfUseOpen = false"
      :isVisible="termsOfUseOpen"
      :terms="termsContent.text"
    />

    <!-- LOADER -->
    <dotLoader v-if="isLoading"></dotLoader>

  </section>
</template>

<script>
  import {
    USER_ACCESS,
    GET_ALL_ANNOUCEMENTS,
    GET_ADVICES,
    GET_ALL_STATUS,
    HOME_LAST_POINTS,
    GET_MAIN_HOME,
    RETROSPECTIVE_INFO,
    GET_MY_TEAM,
    CHECK_TERMS_OF_USE,
    TERMS_OF_USE,
    PDI
  } from '../../../../urlConfig';
  import { REQUEST_SERVICE } from '../../../../requestConfig';
  import { UTIL_SERVICE } from '../../../../utils';
  import dotLoader from '../../components/dotLoader.vue';
  import leftMenu from '../../components/leftMenu.vue';
  import newHeader from '../../components/layouts/newHeader.vue'
  import generalTooltip from '../../components/generalTooltip.vue';
  import ShadowBox from '../../components/layouts/shadowBox.vue'
  import annoucementsCards from '../../components/layouts/annoucementsCards.vue';
  import termsOfUseModal from '../../modals/termsOfUse.vue';
  import confirmationModal from '../../components/confirmationModal.vue'
  import carousel from '../../components/carousel.vue'
  import NewInfoBanner from '../../components/NewInfoBanner.vue'
  import status from '../../components/status.vue';
  import moment from 'moment';
  import axios from 'axios';
  import UAParser from 'ua-parser-js';



  export default {
      name: 'home',
      data() {
        return  {
          PDIData: {},
          modulePersonalDevelopment: false,
          pdiAccess: false,
          isAdmissionModalOpened: false,
          lastAttFromDays: '',
          isLastTenDaysLoading: false,
          myIntervals: {
            updateRefreshPg: null,
            updateProgressAndHoursWorking: null,
            updateTimeNow: null
          },
          nowDate: '',
          currentTime: '',
          showPointCache: false,
          managerData: {},
          isModalOpened: false,
          openModalByHome: false,
          pauseData: {},
          historyListPoints: {},
          menus: {},
          isManager: false,
          myTeam: [],
          points: [],
          isAdmin: false,
          date: '',
          todayId: '',
          actualDay: [],
          isDarkModeActive: false,
          isLoading: false,
          showMood: true,
          userInfo: {},
          isTooltipVisible: false,
          dateNow: '',
          isEndOfJourney: false,
          workData: {
            isInterval: false,
            lastPointRegistered: '',
            remainingHours: '00:00:00',
            workedHours: '00:00',
            workedHoursPercentage: 0,
            workHoursLeft: '00:00:00',
            workingDayTotal: '',
            totalHoursBalance: '00:00',
            isBalanceNegative: false,
            hoursBalanceStartDate: '',
            totalPoints: 0,
            userPointDayStatus: 0,
            isOnCallDuty: false,
            onCallDutyInitDate: null,
            onCallDutyEndDate: null,
          },
          annoucements: [],
          firstResult: {},
          secondResult: {},
          requestedAdvices: [],
          referenceAdvices: [
            {
              type: 1,
              id: '',
              cardTitle: this.$t('Novo comunicado'),
              content: {
                title: '',
                message: '',
                createdAt: '',
              },
              icons: ['newspaper-outline'],
              page: 'detalhes-do-comunicado'
            },
            {
              type: 2,
              id: '',
              cardTitle: this.$t('Assinatura'),
              content: {
                title: '',
                message: this.$t('Você tem uma assinatura pendente, abra para regularizar a solicitação.'),
                createdAt: ''
              },
              icons: ['clipboard-outline', 'pencil'],
              page: 'meus-espelhos'
            },
            {
              type: 3,
              id: '',
              cardTitle: this.$t('Novo chat'),
              content: {
                title: '',
                message: this.$t('Você tem uma nova mensagem no chat clique para ver a mensagem'),
                createdAt: ''
              },
              icons: ['chatbubble-ellipses-outline'],
              page: 'conversas'
            },
            {
              type: 4,
              id: '',
              cardTitle: this.$t('Admissão online'),
              content: {
                title: '',
                message: this.$t('Preencha aqui as informações necessárias de admissão'),
                createdAt: ''
              },
              icons: ['id-card-outline'],
              page: ''
            },
            {
              type: 5,
              id: '',
              cardTitle: this.$t('Chegou um feedback'),
              content: {
                title: '',
                message: this.$t('Você tem um novo Feedback, veja o que estão sentindo do seu trabalho'),
                createdAt: ''
              },
              icons: ['star-outline'],
              page: 'feedback'
            },
            {
              type: 6,
              id: '',
              cardTitle: this.$t('Envio de documento'),
              content: {
                title: '',
                message: this.$t('Você tem um ou mais documentos pendentes para serem enviados'),
                createdAt: ''
              },
              icons: ['document-attach-outline'],
              page: 'documentos'
            },
            {
              type: 7,
              id: '',
              cardTitle: this.$t('Espelho ponto'),
              content: {
                title: '',
                message: this.$t('Você tem um ou mais espelhos de ponto para serem assinados'),
                createdAt: ''
              },
              icons: ['reader-outline'],
              page: 'meus-espelhos'
            },
            {
              type: 8,
              id: '',
              cardTitle: this.$t('Ocorrências'),
              content: {
                title: '',
                message: this.$t('Solicite os ajustes necessários para resolver as suas ocorrências'),
                createdAt: ''
              },
              icons: ['alert-circle-outline'],
              page: 'historico-de-ponto'
            },
          ],
          canSeeHoursBalance: false,
          urlRetrospective: '',
          checkDataRetrospective: [],
          showRetrospective: false,
          hasReminders: false,
          hasMeetings: false,
          hasTask: false,
          termsContent: {
            text: '',
            id: ''
          },
          termsOfUseOpen: false,
        }
      },
      components: {
          ShadowBox,
          leftMenu,
          dotLoader,
          newHeader,
          generalTooltip,
          annoucementsCards,
          status,
          carousel,
          NewInfoBanner,
          confirmationModal,
          termsOfUseModal
      },
      methods: {
        limitObjectiveTitle(title) {
          return UTIL_SERVICE.limitTo(title, 20);
        },
        async getPDI(token) {
          await axios.get(PDI, {
            headers: {
              'Authorization': `Bearer ${token}`,
              companyId: JSON.parse(localStorage.getItem('userInfo')).companyId
            }
          }).then((response) => {
            UTIL_SERVICE.console('RESULT: GET_PDI', response.data);
            this.PDIData = response.data;
          }).catch((err) => {
            UTIL_SERVICE.console('RESULT ERROR PDI:', err)
          })

          // async getMeetingList(token) {
          // await axios.get(GET_MEETINGS_DASH, {
          //   headers: {
          //     'Authorization': `Bearer ${token}`,
          //     companyId: JSON.parse(localStorage.getItem('userInfo')).companyId
          //   }
          // }).then((response)  => {
          //   UTIL_SERVICE.console('RESULT: GET_MEETINGS', response.data);
          //   this.meetingList = response.data;
          //   this.filterNextMeeting(response.data);
          // }).catch((err) => {})
        },
        redirectToV2Function(language, page) {
          UTIL_SERVICE.checkLocationAndRedirectToV2(language, page);
        },
        checkV2RedirectPreference() {
          const redirectPreference = localStorage.getItem('marq_v2_redirect_preference');
          const redirectManager = this.managerData.isManager && redirectPreference === null;
          if (this.modulePersonalDevelopment && (redirectPreference === 'true' || redirectManager)) {
            UTIL_SERVICE.checkLocationAndRedirectToV2('pt', 'dashboard');
          }
        },
        handleRedirectPreferenceFromQuery() {
          const urlParams = new URLSearchParams(window.location.search);
          const stayInWeb = urlParams.get('stayInWeb');

          if (stayInWeb === 'true') {
            localStorage.setItem('marq_v2_redirect_preference', 'false');
            const url = new URL(window.location);
            url.searchParams.delete('stayInWeb');
            window.history.replaceState({}, document.title, url.pathname + url.hash);
          }
        },
        updateTimeNow() {
          this.nowDate.setSeconds(this.nowDate.getSeconds() + 60);
          this.currentTime = moment(this.nowDate, "YYYYMMDD HH:mm").format('HH:mm');
        },
        getMyTeams() {
          const hasTeam = UTIL_SERVICE.getStorage('myTeam');
          if(hasTeam.isManager){
            REQUEST_SERVICE.get(GET_MY_TEAM).then((response) => {
              UTIL_SERVICE.console(this.$t('GET_MY_TEAMS'), response.data);
              this.myTeam = response.data.users;
            });
          }
        },
        filterAdvices() {
          try {
            const types = this.requestedAdvices.map((e) => {
              const obj = {
                type: e.type,
                id: e.id,
                title: e.title,
                createdAt: e.createdAt,
              };
              return obj;
            });

            const result = this.referenceAdvices.filter((e) => {
              return types.some((type) => {
                e.id = type.id;
                e.content.title = type.title;
                e.content.createdAt = type.createdAt;
                return e.type === type.type;
              });
            });

            this.firstResult = result.pop();
            if (this.canSeeHoursBalance === false) {
              this.secondResult = result.pop();
            }

            this.requestedAdvices = result;
          } catch (e) {
            // Handle error
          }
        },
        reloadPage() {
          UTIL_SERVICE.historyLog(false, window.location.pathname, this.$t('realodPage'), { realodProcess: true }, false, null);
          window.location.reload();
        },
        handleCloseModal(value) {
          this.isModalOpened = value;
        },
        handleAdmissionModal(value) {
          this.isAdmissionModalOpened = value;
        },
        initStorages() {
          // Initialize storages with translated strings
          if (!UTIL_SERVICE.getStorage('configProgressPoint')) {
            UTIL_SERVICE.saveStorage('configProgressPoint', {
              totalPoint: 0,
              newPointRegister: 0,
              fromDay: null
            });
          } else {
            const progressPoint = UTIL_SERVICE.getStorage('configProgressPoint');
            if (progressPoint.fromDay !== moment(new Date()).format('DD/MM/YYYY')) {
              UTIL_SERVICE.saveStorage('configProgressPoint', {
                totalPoint: 0,
                newPointRegister: 0,
                fromDay: null
              });
            }
          }

          if (!UTIL_SERVICE.getStorage('lastAttFromDays')) {
            UTIL_SERVICE.saveStorage('lastAttFromDays', '');
          } else {
            const lastAttFromDays = UTIL_SERVICE.getStorage('lastAttFromDays');
            this.lastAttFromDays = lastAttFromDays;
          }

          if (!UTIL_SERVICE.getStorage('todayId')) {
            UTIL_SERVICE.saveStorage('todayId', '');
          } else {
            const todayId = UTIL_SERVICE.getStorage('todayId');
            this.todayId = todayId;
          }

          if (!UTIL_SERVICE.getStorage('firstRequestOfDay')) {
            UTIL_SERVICE.saveStorage('firstRequestOfDay', {
              controlBy24Hours: new Date(moment().add(24, 'hours').format()).getTime(),
              firstRequestOfDay: true,
            });
          } else {
            const firstRequestOfDay = UTIL_SERVICE.getStorage('firstRequestOfDay');
            const newDate = new Date().getTime();

            if (newDate > firstRequestOfDay.controlBy24Hours) {
              firstRequestOfDay.firstRequestOfDay = true;
              firstRequestOfDay.controlBy24Hours = new Date(moment().add(24, 'hours').format()).getTime();
              UTIL_SERVICE.saveStorage('firstRequestOfDay', firstRequestOfDay);
            } else {
              firstRequestOfDay.firstRequestOfDay = false;
              UTIL_SERVICE.saveStorage('firstRequestOfDay', firstRequestOfDay);
            }
          }

          let homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
          if (!homeCtrl) {
            UTIL_SERVICE.saveStorage('homeCtrl', {
              dateAttBalance: moment(new Date()).format('DD/MM/YYYY HH:mm'),
              dateAttNotice: moment(new Date()).format('DD/MM/YYYY HH:mm'),
              dateAttPoints: moment(new Date()).format('DD/MM/YYYY HH:mm'),
              controlByDate: moment(new Date()).format('DD/MM/YYYY'),
              controlBy2Hours: new Date(moment().add(2, 'hours').format()).getTime(),
              controlBy4Hours: new Date(moment().add(4, 'hours').format()).getTime(),
              controlBy1Hour: new Date(moment().add(1, 'hours').format()).getTime(),
              totalOcAndAbs: null,
              balances: null,
              notice: null,
              noticesPending: 0,
              listPoint: null,
              resetPoints: false,
              homeNeedReload: false,
              advicesNeedReload: false,
              lastAttFromDays: '',
              feedbacks: []
            });
          } else {
            if (homeCtrl.controlByDate === moment(new Date()).format('DD/MM/YYYY')) {
              let dataNow = new Date().getTime();

              if (dataNow > homeCtrl.controlBy1Hour) {
                this.getAdvices();
              }

              if (dataNow > homeCtrl.controlBy2Hours) {
                this.getAllNotices();
              }

              if (dataNow > homeCtrl.controlBy4Hours || homeCtrl.resetPoints) {
                this.getMainHome();
              }
            }
          }

          if (!UTIL_SERVICE.getStorage('historyListPoints')) {
            UTIL_SERVICE.saveStorage('historyListPoints', {
              list: [],
              count: null,
              showList: false,
              showNew: false,
              dateAtt: null,
              controlBy1Hours: null
            });
          }

          if (!UTIL_SERVICE.getStorage('pointHistoryCtrl')) {
            UTIL_SERVICE.saveStorage('pointHistoryCtrl', {
              dateAtt: null,
              getRequest: true,
              initDate: null,
              endDate: null,
              listHistory: []
            });
          }

          if (!UTIL_SERVICE.getStorage('myOccurrenceCtrl')) {
            UTIL_SERVICE.saveStorage('myOccurrenceCtrl', {
              data: null,
              dateAtt: null,
              controlBy4Hours: null
            });
          }

          if (!UTIL_SERVICE.getStorage('userProfile')) {
            UTIL_SERVICE.saveStorage('userProfile', {
              data: null
            });
          }

          if (!UTIL_SERVICE.getStorage('mirrorCtrl')) {
            UTIL_SERVICE.saveStorage('mirrorCtrl', {
              dateAtt: null,
              dataControl: null,
              data: null,
              pageNumber: null,
              haveMore: null
            });
          }

          if (!UTIL_SERVICE.getStorage('myRequestsCtrl')) {
            UTIL_SERVICE.saveStorage('myRequestsCtrl', {
              dateAtt: null,
              dataControl: null,
              data: null
            });
          }

          if (!UTIL_SERVICE.getStorage('hourBalanceCtrl')) {
            UTIL_SERVICE.saveStorage('hourBalanceCtrl', {
              data: null,
              dateAtt: null,
              dataControl: null
            });
          }
        },
        configInfoPointCache(totalPoints) {
          try {
            const dataConfigProgressPoint = UTIL_SERVICE.getStorage('configProgressPoint');
            if (dataConfigProgressPoint.newPointRegister) {
              if (dataConfigProgressPoint.newPointRegister > totalPoints) {
                this.showPointCache = true;
              } else {
                UTIL_SERVICE.saveStorage('configProgressPoint', {
                  totalPoint: totalPoints,
                  newPointRegister: totalPoints,
                  fromDay: moment(new Date()).format('DD/MM/YYYY')
                });
              }
            } else {
              UTIL_SERVICE.saveStorage('configProgressPoint', {
                totalPoint: totalPoints,
                newPointRegister: totalPoints,
                fromDay: moment(new Date()).format('DD/MM/YYYY')
              });
            }
          } catch (e) {}
        },
        redirectToTodayDetails(id) {
          this.$router.push(`/detalhe-do-ponto/${id}/5`);
        },
        redirectToHoursBalance() {
          this.$router.push('/saldo-de-horas');
        },
        redirectToDayDetails(id) {
          this.$router.push(`/detalhe-do-ponto/${id}/5`);
        },
        checkIfDarkModeIsActive() {
          const isDark = JSON.parse(localStorage.getItem('darkMode'));
          if (isDark) {
            this.isDarkModeActive = isDark.dark;
          }
        },
        getUserInfo() {
          this.userInfo = UTIL_SERVICE.getStorage('userInfo');
        },
        getHomeInfo() {
          this.isLoading = true;
          let browserInfo = UTIL_SERVICE.checkBrowser();
          let url = USER_ACCESS;
          // const { dark } = JSON.parse(window.localStorage.getItem('darkMode'))

          url += "?i=" + this.userInfo.id;
          url += "&deviceModel=" + browserInfo.name;
          url += "&version=" + browserInfo.version;
          url += "&deviceId=" + UTIL_SERVICE.getStorage('browserId');
          if ($('#identifier').attr('class'))
            url += "&pushToken=" + $('#identifier').attr('class');

          // try {
          //   if(dark === true) {
          //   url += "&themeMode=" + "2"
          //   } else {
          //     url += "&themeMode=" + "1"
          //   }
          // } catch (error) {

          // }

          REQUEST_SERVICE.get(url).then((response) => {
            UTIL_SERVICE.console("RESULT USER_ACCESS: ", response.data);
            UTIL_SERVICE.console("RESULT CHECK RETROSPECTIVE: ", this.checkDataRetrospective);
            this.isLoading = false;
            if(this.checkDataRetrospective) this.showRetrospective = response.data.showRetrospective;
            else this.showRetrospective = false;

            const logoWeb = response.data.logoWebUri;

            localStorage.setItem('logoWebUri', JSON.stringify({logoWebUri: logoWeb}));
            localStorage.setItem('userAccess', JSON.stringify(response.data));
            this.hasNotification = response.data.hasNotification;
            localStorage.setItem('hasNotification', JSON.stringify(response.data.hasNotification));
            const userAccess = JSON.parse(localStorage.getItem('userAccess'));
            const userInfo = JSON.parse(localStorage.getItem('userInfo'));

            userInfo.office = userAccess.officeName;

            this.userInfo = userInfo;

            localStorage.setItem('userInfo', JSON.stringify(userInfo));

            this.showMood = userAccess.showMood;

            const dateLastPoint = UTIL_SERVICE.getStorage('dataDateLastPoint');
            this.workData.hoursBalanceStartDate = moment(response.data.oldestDate).format('DD/MM/YYYY');
            this.workData.totalHoursBalance = response.data.totalHoursBalance;

           try {
             if (dateLastPoint) {
               const dateLastPointTime = new Date(dateLastPoint.date);
               const responseLastPointTime = new Date(response.data.lastPoint);
               if (dateLastPointTime > responseLastPointTime) {
                this.workData.lastPointRegistered = moment(dateLastPoint.date).format('DD/MM/YYYY HH:mm');
              } else {
                this.workData.lastPointRegistered = moment(response.data.lastPoint).format('DD/MM/YYYY HH:mm');
              }
            } else {
              this.workData.lastPointRegistered = moment(response.data.lastPoint).format('DD/MM/YYYY HH:mm');
            }
           } catch (error) {
            this.workData.lastPointRegistered = response.data.lastPoint;
           }

            this.canSeeHoursBalance = response.data.canSeeHoursBalance;

            const historyListPointsCtrl = UTIL_SERVICE.getStorage('historyListPoints');
            historyListPointsCtrl.controlBy1Hours = new Date(moment().add(1, 'hours').format()).getTime();
            historyListPointsCtrl.dateAtt = moment(new Date()).format('DD/MM/YYYY HH:mm');
            historyListPointsCtrl.showNew = response.data.hasNotification;
            historyListPointsCtrl.count = null;


            UTIL_SERVICE.saveStorage('historyListPoints', historyListPointsCtrl)
          }).catch(reason => {
            this.isLoading = false;
            UTIL_SERVICE.console("RESULT ERROR:", reason.data);
          })
        },
        showTooltip() {
          this.isTooltipVisible = true;
        },
        hideTooltip() {
          this.isTooltipVisible = false;
        },
        handleTooltip(isVisible) {
          this.isTooltipVisible = isVisible;
        },
        getMainHome() {
          let url = HOME_LAST_POINTS;
          url += "?i=" + this.userInfo.id;

          if(!this.isLastTenDaysLoading) {
            this.isLastTenDaysLoading = true;
            REQUEST_SERVICE.get(url).then((response) => {
            UTIL_SERVICE.console("RESULT HOME_LAST_POINTS:", response.data)

            this.points = response.data.points;

            if(this.points.length >= 0) {
              this.todayId = this.points[0].id;
              UTIL_SERVICE.saveStorage('todayId', this.todayId);
            }

            this.actualDay = this.points.shift();

            this.configInfoPointCache(response.data.totalPoints);

            this.lastAttFromDays = moment(new Date()).format('DD/MM/YYYY HH:mm')

            UTIL_SERVICE.saveStorage('lastAttFromDays', this.lastAttFromDays);

            UTIL_SERVICE.saveStorage('configProgressPoint',{
              totalPoint: response.data.totalPoints,
              newPointRegister: response.data.totalPoints,
              fromDay: moment(new Date()).format('DD/MM/YYYY')
            });

            const homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
            homeCtrl.listPoint = response.data.points;
            homeCtrl.totalOcAndAbs = response.data.totalOccurrences;
            homeCtrl.lastAttFromDays = this.lastAttFromDays
            homeCtrl.resetPoints = false;

            UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl)

            this.isLastTenDaysLoading = false;

          }).catch(reason => {
            this.isLoading = false;
            this.isLastTenDaysLoading = false;
            UTIL_SERVICE.console("GET_MAIN_HOME ERROR:", reason);
          })
          }
        },
        initCountdown() {
          if(this.workData.totalPoints % 2 !== 0 && this.workData.userPointDayStatus === 2 && this.userInfo.workShift.workShiftType !== 4 && this.userInfo.workShift.workShiftType !== 3 && this.workData.remainingHours !== "00:00:00") {
            this.isInterval = false;
              //---------------------remaininghours-------------------------
            const remaininghours = moment(this.workData.remainingHours, 'HH:mm:ss');
            // const remaininghours = moment('04:58:22', 'HH:mm:ss');

            //-------------------------workedHours-------------
            const workedHours = moment(this.workData.workedHours, 'HH:mm:ss');
            // const workedHours = moment('00:00:00', 'HH:mm:ss');

            const [workingDayTotal] = this.workData.workingDayTotal.split(':')

            this.timer = setInterval(() => {
              remaininghours.subtract(1, 'second');

              workedHours.add(1, 'second');

              //-----------------------------------------------------------
              const secondsRemaining = `${Math.floor(remaininghours.seconds()) > 0 ? remaininghours.seconds() : 0}`;
              const minutesRemaining = `${Math.floor(remaininghours.minutes()) > 0 ? remaininghours.minutes() : 0}`;
              const hoursRemaining = `${Math.floor(remaininghours.hours()) > 0 ? remaininghours.hours() : 0}`;

              const secondsWorked = `${Math.floor(workedHours.seconds()) > 0 ? workedHours.seconds() : 0}`
              const minutesWorked =`${Math.floor(workedHours.minutes()) > 0 ? workedHours.minutes() : 0}`
              const hoursWorked = `${Math.floor(workedHours.hours()) > 0 ? workedHours.hours() : 0}`

              this.workData.workedHours = `${this.addDigitZeroToTime(hoursWorked)}:${this.addDigitZeroToTime(minutesWorked)}`

              this.workData.workHoursLeft = `${this.addDigitZeroToTime(hoursRemaining)}:${this.addDigitZeroToTime(minutesRemaining)}:${this.addDigitZeroToTime(secondsRemaining)}`

              const timeConvertedInSeconds = this.convertHoursAndMinutesToSeconds(hoursWorked, minutesWorked, secondsWorked);

              this.workData.workedHoursPercentage = this.calculateWorkedHoursPercentage(timeConvertedInSeconds, workingDayTotal);

              // if(remaininghours ===  "00:00:00") {
                // clearInterval(this.timer)
                // clearTimeout(this.timer);
              // }
            if (parseInt(this.workData.workHoursLeft.split(':').join('')) === 0) {
              this.isEndOfJourney = true;
              clearInterval(this.timer)
              clearTimeout(this.timer);
            }

            }, 1000)

            } else {
              clearInterval(this.timerInterval);
              this.isInterval = true;
              this.workData.workHoursLeft = this.workData.remainingHours
            }
        },
        getAllNotices() {
          this.isLoading = true;
          this.checkIfDarkModeIsActive();
          const url = GET_ALL_ANNOUCEMENTS + "?pageQtd=4&pageNumber=1&device=web"

          REQUEST_SERVICE.get(url).then((response) => {
            UTIL_SERVICE.console('GET_ALL_NOTICES', response.data.result.list);
            this.annoucements = response.data.result.list;

            const homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
            homeCtrl.notice = this.annoucements;

            UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl)
          })
          .catch(reason => {
            this.isLoading = false;
            UTIL_SERVICE.console("GET_ALL_NOTICES ERROR:", reason.data);
          });
        },
        getAllStatus() {
          this.isLoading = true;
          const url = GET_ALL_STATUS + "?device=web"

          REQUEST_SERVICE.get(url).then((response) => {
            UTIL_SERVICE.console('GET_ALL_STATUS', response.data)

            this.date = response.data.date;

            this.nowDate = new Date(response.data.date);
            this.currentTime = moment(this.nowDate, "YYYYMMDD HH:mm").format('HH:mm');
            this.myIntervals.updateTimeNow = setInterval(() => this.updateTimeNow(), 60000);

            this.dateNow = moment(response.data.date).format('DD/MM/YYYY HH:mm');
            if(response.data.workedHours) {
              this.workData.workedHours = response.data.workedHours.slice(0, -3);
            }

            this.workData.workingDayTotal = response.data.workingDayTotal;
            this.workData.isBalanceNegative = response.data.isBalanceNegative;
            this.workData.remainingHours = response.data.hoursMissing;
            if(parseInt(response.data.hoursMissing.split(':').join('')) === 0) {
              this.isEndOfJourney == true;
            }
            this.workData.totalPoints = response.data.totalPoints;
            this.workData.workedHoursPercentage = response.data.workedHoursPercentage;
            this.workData.userPointDayStatus = response.data.userPointDayStatus;

            this.workData.isOnCallDuty = response.data.isOnCallDuty;
            this.workData.onCallDutyInitDate = response.data.onCallDutyInitDate;
            this.workData.onCallDutyEndDate = response.data.onCallDutyEndDate;

            const homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
            const balances = {
              balance: response.data.totalHoursBalance,
              positive: response.data.positive,
              month: moment(response.data.oldestDate).format('DD/MM/YYYY')
            }

            homeCtrl.balances = balances;

            this.initCountdown()

            UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl)
          }).catch(reason => {
            this.isLoading = false;
            UTIL_SERVICE.console("GET_ALL_STATUS ERROR:", reason.data);
          })
        },
        getAdvices() {
          const url = GET_ADVICES + "?device=web"

          if(this.userInfo.company.locale == 0) {
            REQUEST_SERVICE.get(url).then((response) => {
            UTIL_SERVICE.console('GET_ADVICES', response.data)

            if(response.data) {
              this.requestedAdvices = response.data;

              if(this.requestedAdvices.find((e) => e.type === 9)) {
                this.hasMeetings = true;
              }

              if(this.requestedAdvices.find((e) => e.type === 10)) {
                this.hasReminders = true;
              }

              if(this.requestedAdvices.find((e) => e.type === 12)) {
                this.hasTask = true;
              }

              const homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
              homeCtrl.advices = this.requestedAdvices;

              UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl)
            }

            this.filterAdvices();
          }).catch(reason => {
            UTIL_SERVICE.console("GET_ADVICES ERROR:", reason.data);
          })
          }

        },
        redirectTo(page, id, type) {
          if(type === 2) {
            this.isModalOpened = true;
          }
          else if(type === 4) {
            this.isAdmissionModalOpened = true;
            // this.$router.push(`/${page}`)
          } else if( type === 8) {
            UTIL_SERVICE.saveStorage('redirectedFromHome', true);
            this.$router.push(`/${page}`)
          }
          else {
            this.$router.push(`/${page}/${id}`);
          }
        },
        checkLastTenDaysStatus(status1, status2, status3) {
          switch(true) {
            case status3 === 1 || status3 === 11:
              return {
                backgroundColor: '#A313BB',
                text: this.$t('Férias'),
                icon: 'airplane'
              }

              case status3 > 0 && (status3 !== 1 || status3 !== 11):
              return {
                backgroundColor: '#7E8DA7',
                text: this.$t('Afastamento'),
                icon: 'checkmark-circle'
              }
            case status2 === 1:
              return {
                backgroundColor: '#FFAB2D',
                text: this.$t('Solicitado'),
                icon: 'build'
              }

            case status2 === 2:
              return {
                backgroundColor: '#2AC166',
                text: this.$t('Aprovado'),
                icon: 'build'
              }

            case status2 === 3:
              return {
                backgroundColor: '#FF445D',
                text: this.$t('Recusado'),
                icon: 'build'
              }

            case status1 === 3:
              return {
                backgroundColor: '#2AC166',
                text: this.$t('Concluído'),
                icon: 'checkmark-circle'
              }

            case status1 === 4:
              return {
                backgroundColor: '#FFAB2D',
                text: this.$t('Ocorrência'),
                icon: 'warning'
              }

            case status1 === 5:
              return {
                backgroundColor: '#FF445D',
                text: this.$t('Falta'),
                icon: 'remove-circle'
              }
            default:
              return {
                backgroundColor: '#1b59f8',
                text: this.$t('Dia atual'),
                icon: 'today-outline'
              }
          }
        },
        addDigitZeroToTime(string) {
          if(string.length < 2) {
            return `0${string}`
          } else {
            return string;
          }
        },
        convertHoursAndMinutesToSeconds(hours, minutes, seconds) {
          if(!hours) {
            hours = 0;
          }

          if(!minutes) {
            minutes = 0;
          }

          if(!seconds) {
            seconds = 0;
          }

          return Number(hours * 3600) + Number(minutes * 60) + Number(seconds);
        },
        calculateWorkedHoursPercentage(seconds, maxWorkHours) {
          const totalSeconds = this.convertHoursAndMinutesToSeconds(Number(maxWorkHours), null, null)

          const percentage = (seconds / totalSeconds) * 100;
          if(percentage <= 100) {
            return percentage
           } else {
            return 100
          }
        },
        populateLastPointsWithCache(homeCtrl, arrayToPopulate) {
          if(arrayToPopulate === 'listPoint') {
            this.points = homeCtrl.listPoint;
          } else if(arrayToPopulate === 'notices') {
            this.annoucements = homeCtrl.notice;
          } else if(arrayToPopulate === 'advices') {
            // const isPendingFeedback = homeCtrl.feedbacks.some((e) => {
            //   return e.readAt;
            // })

            // if(isPendingFeedback) {
            //   this.requestedAdvices = homeCtrl.advices.filter((e) => {
            //     return e.type !== 5;
            //   })

            //   this.filterAdvices();
            // } else {
            //   this.requestedAdvices = homeCtrl.advices;
            //   this.filterAdvices();
            // }

            this.requestedAdvices = homeCtrl.advices;
            if(this.requestedAdvices.find((e) => e.type === 9)) {
              this.hasMeetings = true;
            }
            if(this.requestedAdvices.find((e) => e.type === 10)) {
              this.hasReminders = true;
            }
            this.filterAdvices();
          }
        },
        getRetrospectiveInfo() {
          REQUEST_SERVICE.get(RETROSPECTIVE_INFO).then((response) => {
            UTIL_SERVICE.console('GET_RETROSPECTIVE', response)
            let dataRetrospective = response.data;
            this.checkDataRetrospective = response.data
            let url = ''

            if (window.location.href.includes('localhost:8080')) {
              url = 'http://localhost:63342/MarQ.Landpage/retrospectiva.html?_ijt=o9rldnv4jth9hpl4fldtrc1udb&_ij_reload=RELOAD_ON_SAVE';
            } else if (window.location.href.includes('web-dev') || window.location.href.includes('marqponto-web-slot')) {
              url = 'https://marqponto-site-stag.azurewebsites.net/retrospectiva'
            } else {
              url = 'https://marqponto.com.br/retrospectiva';
            }

            url += '?ui=' + this.userInfo.id;
            url += '&cs=' + this.userInfo.company.contextCode;
            url += '&im=' + this.isAdmin;

            if(dataRetrospective) {
              if (this.isAdmin) {
              url += '&gu=' + dataRetrospective.companyIncreaseRegisteredEmployees;
              url += '&np=' + dataRetrospective.companyNewEmployeesAdmission;
              url += '&rh=' + dataRetrospective.companyReturnedHours;
              url += '&chw=' + dataRetrospective.companyTotalHoursWorked;
            } else {
                url += '&etp=' + dataRetrospective.userTotalPoints;
                url += '&es=' + dataRetrospective.userTotalSignatures;
                url += '&etf=' + dataRetrospective.userTotalFeedbacks;
                url += '&eoc=' + dataRetrospective.userTotalOfficeChanges;
                url += '&ev=' + dataRetrospective.userTotalVacations;
                url += '&ea=' + dataRetrospective.userTotalSolicitedAdjustments;
                url += '&ect=' + dataRetrospective.userTotalCompanyTimeInDays;
              }

            }

            this.urlRetrospective = url;
          })
        },
        watchForToken() {
          const token = JSON.parse(localStorage.getItem('authUser')).v2Token
          if (token) {
            this.handleToken(token)
            return
          }

          const intervalId = setInterval(() => {
            const token = JSON.parse(localStorage.getItem('authUser')).v2Token
            if (token) {
              this.handleToken(token)
              clearInterval(intervalId)
            }
          }, 1000)
        },
        async handleToken(token) {
          this.token = token
          //TODO: MOVE THIS AWAY, THIS FUNCTION SHOULD ONLY HANDLE TOKEN, ITS NOT SUPPOSED TO DO THE APIV2 REQUESTS
          try {
            await this.getPDI(token)
            await this.fetchTermsOfUse(token)

          } catch (error) {
            console.error('Failed to fetch terms of use:', error)
          }
        },
        async fetchTermsOfUse(token) {
          return await axios.get(CHECK_TERMS_OF_USE, {
            headers: {
              'Authorization': `Bearer ${token}`,
              companyId: JSON.parse(localStorage.getItem('userInfo')).companyId
            }
          }).then((response)  => {
          }).catch(async (err) => {
            if(err.response.status == 404) {
              await this.fetchNewTermsOFUse(token)
            }
          })
        },
        async fetchNewTermsOFUse(token) {
          return await axios.get(TERMS_OF_USE, {
            headers: {
              'Authorization': `Bearer ${token}`,
              CompanyId: JSON.parse(localStorage.getItem('userInfo')).companyId
            }
          }).then((response) => {
              if(response.data) {
                this.termsOfUseOpen = true;
                this.termsContent.text = response.data.url + "#toolbar=0"
                this.termsContent.id = response.data.id
              }
          }).catch((err) => {
          })
        },
        async handleAccept() {
          let parser = new UAParser();
          let result = parser.getResult();
          const token = JSON.parse(localStorage.getItem('authUser')).v2Token

          let browserInfo = UTIL_SERVICE.checkBrowser();
          let url = CHECK_TERMS_OF_USE;
          // const { dark } = JSON.parse(window.localStorage.getItem('darkMode'))

          url += "?i=" + this.userInfo.id;
          url += "&deviceModel=" + browserInfo.name;
          url += "&version=" + browserInfo.version;
          url += "&deviceId=" + UTIL_SERVICE.getStorage('browserId');

          const body = {
            termsOfUseId: this.termsContent.id,
            wasAccepted: true,
            url: this.removeToolbarParam(this.termsContent.text),
            platformVersion: result.browser.version,
            acceptPlatform: 1
          };

          await axios.post(url, body, {
            headers: {
              'Authorization': `Bearer ${token}`,
              CompanyId: JSON.parse(localStorage.getItem('userInfo')).companyId
            }
          }).then((res) => {
            if(res.status === 200) {
              this.termsOfUseOpen = false
            }
          })
          this.termsOfUseOpen = false;
        },
        handleReject() {
          this.logoutMenu()
          this.termsOfUseOpen = false;
        },
        removeToolbarParam(url) {
          if (!url) return url;

          return url.replace(/#toolbar=0/g, '');
        },
        logoutMenu: function () {
          REQUEST_SERVICE.logout().then((response) => {
            window.localStorage.removeItem("dateLastPointConfirm");
            window.localStorage.removeItem("logoWebUri");
            window.localStorage.removeItem("homeCtrl");
            window.localStorage.removeItem("myTeam");
            window.localStorage.removeItem("configProgressPoint");
            window.localStorage.removeItem("solicitationCtrl");
            window.localStorage.removeItem("historyListPoints");
            window.localStorage.removeItem("pointHistoryCtrl");
            window.localStorage.removeItem("myOccurrenceCtrl");
            window.localStorage.removeItem("myRequestsCtrl");
            window.localStorage.removeItem("mirrorCtrl");
            window.localStorage.removeItem("hourBalanceCtrl");
            window.localStorage.removeItem("showFeelings");
            window.localStorage.removeItem("dataConfirmPoint");
            window.localStorage.removeItem("userProfile");
            window.localStorage.removeItem("hourBalance");
            window.localStorage.removeItem("3hours");
            window.localStorage.removeItem("authUser");
            window.localStorage.removeItem("configMenu");
            window.localStorage.removeItem("menus");

            UTIL_SERVICE.historyLog(false, window.location.pathname, 'logoutMenu', null, false, null);
            UTIL_SERVICE.setTheme();

            const partner = UTIL_SERVICE.getStorage('partner');

            if (partner && partner === 1) {
              this.$router.push({ path: '/villafacil' });
            } else {
              this.$router.push({ path: '/login' });
            }
          });
        },
      },
      computed: {
        currentRouteName() {
          return this.$route.path;
        },
        returnUserPointDayStr() {
          switch(this.workData.userPointDayStatus) {
            case 1:
              return 'Intervalo';
            case 2:
              return 'Trabalhando';
            case 3:
              return 'Concluído'
            default:
              return ''
          }
        },
      },
      beforeDestroy() {
        clearInterval(this.timerInterval); // Clean up timer
      },
      watch: {
        managerData: function (value) {
          if (value.isManager) {
            this.checkV2RedirectPreference();
          }
        }
      },
      beforeMount() {
        this.getUserInfo();
        this.getRetrospectiveInfo();
        //this.getMyTeams()
        this.getAllNotices();
        const homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');

        this.initStorages();
        const firstRequest = UTIL_SERVICE.getStorage('firstRequestOfDay');

        if(firstRequest.firstRequestOfDay) {
          this.getMainHome();
          this.getAdvices();
        }

        if(!homeCtrl) {
          this.getMainHome();
          this.getAdvices();
        } else {
          this.populateLastPointsWithCache(homeCtrl, 'listPoint')
          this.populateLastPointsWithCache(homeCtrl, 'notices')
          if (homeCtrl.advices) {
            this.populateLastPointsWithCache(homeCtrl, 'advices')
            if (homeCtrl.advices.find((e) => e.type === 12)) {
              this.hasTask = true;
            }
          }
        }

        this.getHomeInfo();
        this.getAllStatus();


        try {
          if(homeCtrl.homeNeedReload) {
            this.getMainHome();
          }
        } catch(e) {}

        try {
          if(homeCtrl.advicesNeedReload || !homeCtrl.advices) {
           this.getAdvices();
          }
        } catch(e) {}

        homeCtrl.homeNeedReload = false;
        homeCtrl.advicesNeedReload = false;

        firstRequest.firstRequestOfDay = false;
        UTIL_SERVICE.saveStorage('firstRequestOfDay', firstRequest);

        UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl);
      },
      created() {
        this.watchForToken();
        this.handleRedirectPreferenceFromQuery();
      },
  }
</script>

<style lang="scss">
  .content-modal-wrapper {
    max-width: 321px;
    text-align: center;

    #pencil-icon {
      position: absolute;
      left: 164px;
    }

    span {
      color: var(--text);
    }

    #modal-content-bold {
      font-weight: 600;
    }

    .redirect-wrapper  {
      gap: 16px;
      display: flex;

      svg {
        cursor: pointer;
      }
    }

    .footer-modal {
      color: var(--darkBlue) !important;
      font-weight: 600;
    }
  }

  .retrospective-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    max-width: 1496px;
    padding: 32px 25px;
    border-radius: 10px;
    background: #1B59F8;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.25);
    margin-top: 40px;
    overflow: hidden;
    text-decoration: none !important;

    .retrospective-card-detail {
      position: absolute;
      right: 670px;

      ion-icon {
        font-size: 360px;
        color: #fff;
        opacity: .2;
      }
    }

    .retrospective-card-title {
      display: flex;
      gap: 14px;

      ion-icon {
        font-size: 60px;
        color: #fff;
        opacity: .3;
      }

      p {
        font-size: 22px;
        color: #fff;
        max-width: 25ch;
        line-height: 1;
        margin-top: 7px;

        span {
          font-weight: 600;
        }
      }
    }

    .retrospective-card-link {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 8px;
      font-size: 18px;
      font-weight: 700;
      text-decoration: none;
      color: #1B59F8;
      background: #fff;
      border-radius: 14px !important;
      cursor: pointer;
      z-index: 2;

      ion-icon {
        font-size: 27px;
        color: #1B59F8;
        margin-top: -2px;
      }
    }

    .retrospective-card-logo {
      display: flex;
      flex-direction: column;
      position: relative;

      ion-icon {
        font-size: 22px;
        color: #fff;
        position: absolute;
        top: 7px;
      }

      span {
        font-size: 27px;
        font-weight: 700;
        color: #fff;
        margin-left: 26px;
      }

      img {
        width: 112px;
      }
    }
  }

  .home-mid-wrapper {
    display: flex;
    justify-content: flex-start;
    gap : 32px;
    margin-top: 51px;
    margin-bottom: 20px;
    position: relative;
    flex-grow: 1;
    min-width: 350px;
    max-width: 1496px;
    flex-wrap: wrap;
  }

  .left-column {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 23px;

    .onCall-card {
      padding: 24px 24px;
      display: flex;
      flex-direction: column;
      gap: 8px;
      transition: 0.3s;

      .title {
        transition: 0.5s;
        background: var(--darkBlue);
        padding: 16px 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        align-self: stretch;
        border-radius: 8px;
        color: var(--textTag);
        font-family: Montserrat;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 125.303%;
        position: relative;
        overflow: hidden;

        .clock-svg {
          position: absolute;
          right: -10px;
        }
      }

      .content {
        display: flex;
        font-size: 13px;
        justify-content: space-between;
        font-weight: 500;
        color: var(--grayText);
        border-bottom: 1px solid var(--border);
        padding-bottom: 5px;

        div {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
        }

        span:last-child {
          font-size: 11px;
        }
      }
    }

    .hours-remaining-home-card {
      padding: 0px 17px;
      height: 344px;
      width: 350px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      .top-hours-remaining-home-card {
        display: flex;
        align-items: center;
        height: 97px;
        position: relative;
        width: 80%;
        justify-content: center;

        .mid-line {
          path {
            transition: 0.5s;
            stroke: var(--border);
          }
        }

        .top-hours-remaining-home-card-wrapper {
          width: 100%;
          display: flex;
          gap: 25px;
          align-items: center;
          justify-content: center;

          .left-box {
            color: #7E8DA7;
            flex: 1 1 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .day-title {
              font-weight: 400;
              font-size: 14px;
            }

            .day-content {
              font-weight: 600 !important;
              font-size: 20px !important;
            }
          }

          .right-box {
            color: #7E8DA7;
            position: relative;
            flex: 1 1 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            .remaining-hours-tooltip {
              position: absolute;
              right: 15px;
              top: 23px;
            }

            .day-title {
              font-weight: 400;
              font-size: 14px;
            }

            .day-content {
              font-weight: 600 !important;
              font-size: 20px !important;
            }
          }
        }
      }

      .last-point-registered-tag {
        transition: 0.5s;
        display: flex;
        justify-content: center;
        padding: 5px 20px 6px 19px;
        width: 106%;
        height: 29px;
        border-radius: 10px;
        border: 1px solid var(--darkBlue);
        background: var(--darkBlue);
        color: var(--textTag);
        position: absolute;
        left: -10px;
        top: 100px;

        .text-first-part {
          font-size: 13px;
          font-weight: 400;
        }

        .text-second-part {
          font-size: 13px;
          font-weight: 600;
        }
      }

      .hours-remaining {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 53px;

        .hours-remaining-title {
          font-size: 13px;
          font-weight: 400;
          color: var(--text);
        }

        .hours-remaining-content {
          color: var(--text) !important;
          font-size: 30px;
          font-weight: 500;
        }
      }

      .point-cache-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 42px;

        button {
          transition: 0.5s;
          display: flex;
          padding: 8px 12px;
          gap: 10px;
          border-radius: 20px;
          border: 1px solid var(--darkBlue);
          background: var(--leftMenuColor);
          color: var(--darkBlue);
          min-width: 171px;
          align-items: center;
          justify-content: space-between;

          ion-icon {
            transition: 0.5s;
            color: var(--darkBlue)
          }
        }

        svg {
          path:first-child {
            stroke: var(--darkBlue);
          }

          path:last-child {
            fill: var(--darkBlue);
          }
        }

        span:nth-child(2) {
          color: var(--darkBlue);
          margin-bottom: 17px;
        }

        span:nth-child(3) {
          color: #7E8DA7;

          span{
            font-weight: 600;
          }
        }

        span:nth-child(4) {
          color: #7E8DA7;
          margin-bottom: 17px;
        }
      }

      .hours-remaining-progress-bar {
        width: 275px;
        height: 6px;
        border-radius: 20px;
        background: rgba(27, 89, 248, 0.10);
        border: none;
        margin-top: 40px;

        .percentage-progress-bar {
          transition: 0.5s;
          height: 6px;
          border-radius: 20px;
          border: none;
          background: linear-gradient(90deg, var(--darkBlue), var(--gradientWhite));
          background-size: 400% 400%;
          animation: gradient 4s ease infinite;
        }

        .reference-hours-wrapper {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
          color: var(--text);
          font-size: 11px;

          .right-reference-hours {
            top: -20px;
            left: 1px;
            position: absolute;
          }

          .left-reference-hours {
            top: -20px;
            right: 1px;
            position: absolute;
          }
        }

        .progress-status{
          color: var(--darkBlue);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: 600;
        }
      }

      @keyframes gradient {
        0% {
          background-position: 0% 25%;
        }
        50% {
          background-position: 100% 50%;
        }
        100% {
          background-position: 0% 50%;
        }
      }

      .see-details-button {
        cursor: pointer;
        transition: color 0.3s ease;
        text-decoration: none;
        font-weight: 500;
        margin-top: 41px;
        font-size: 15px;
        color: #7E8DA7;
        text-align: center;
      }

      .see-details-button:hover {
        color: var(--activeHoverSidebar);
      }
    }

    .pause-home-card {
      padding: 0px 17px;
      height: 344px;
      width: 350px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: var(--pausedBox) !important;
      position: relative;
      z-index: 5;

      .bg-img-top {
        position: absolute;
        right: 0;
      }

      .bg-img-bottom {
        position: absolute;
        left: 0;
        bottom: 0;
      }

      .top-pause-home-card {
        display: flex;
        align-items: center;
        height: 97px;
        position: relative;
        width: 80%;
        justify-content: center;

        .top-pause-home-card-wrapper {
          width: 100%;
          display: flex;
          gap: 25px;
          align-items: center;
          justify-content: center;

          .left-box {
            color: #fff;
            flex: 1 1 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .day-title {
              font-weight: 400;
              font-size: 14px;
            }

            .day-content {
              font-weight: 600 !important;
              font-size: 20px !important;
            }
          }

          .pause-mid-line {
            path {
              transition: 0.5s;
              stroke: var(--border);
            }
          }

          .right-box {
            color: #fff;
            position: relative;
            flex: 1 1 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            .remaining-hours-tooltip {
              position: absolute;
              right: 21px;
              top: 23px;
              fill: #fff;
              stroke: #fff
            }

            .day-title {
              font-weight: 400;
              font-size: 14px;
            }

            .day-content {
              font-weight: 600 !important;
              font-size: 20px !important;
            }
          }
        }
      }

      .last-pause-registered-tag {
        display: flex;
        justify-content: center;
        padding: 5px 20px 6px 19px;
        width: 106%;
        height: 29px;
        border-radius: 10px;
        border: 1px solid var(--blueText);
        background: #fff;
        color: var(--darkText);
        position: absolute;
        left: -10px;
        top: 100px;

        .text-first-part {
          font-size: 13px;
          font-weight: 400;
        }

        .text-second-part {
          font-size: 13px;
          font-weight: 600;
        }
      }

      .pause-text {
        color: #fff;
        display: flex;
        align-items: center;
        margin-top: 53px;
        font-size: 26px;
        font-weight: 400;

        span {
          font-weight: 700;
        }
      }

      .pause-title {
        font-size: 18px;
        color: #fff;
      }

      .pause-progress-bar {
        width: 275px;
        height: 6px;
        border-radius: 20px;
        background: var(--pausedProgressBar);
        border: none;
        margin-top: 40px;

        .percentage-progress-bar {
          height: 6px;
          border-radius: 20px;
          border: none;
          background: linear-gradient(90deg, var(--pausedGradientBarStart) 0%, var(--pausedGradientBarEnd) 97.26%);
          background-size: 400% 400%;
          animation: gradient 4s ease infinite;
        }

        .reference-hours-wrapper {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
          color: #fff;
          font-size: 13px;

          .right-reference-hours {
            top: -22px;
            left: 1px;
            position: absolute;
            font-weight: 700;
          }

          .left-reference-hours {
            top: -22px;
            right: 1px;
            position: absolute;
            font-weight: 700;
          }
        }
      }

      .button-return-pause {
        border: none;
        display: inline-flex;
        padding: 4px 10px 4px 6px;
        justify-content: center;
        align-items: center;
        gap: 4px;
        border: 1px solid var(--blueText);
        background: var(--leftMenuColor);
        color: var(--blueText);
        border-radius: 20px;
        font-weight: 600;
        margin-top: 20px;
      }
    }

    .background-pause {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
      background: rgba(255,255,255, 0.5);
      width: 100%;
      text-align: center;
      position: fixed;
      z-index: 4;
      bottom: 0;
      top: 0;
      right: 0;
      left: 0;
      overflow: auto;
    }

    .hours-balance-card {
      cursor: pointer;
      width: 100%;
      height: 92px;
      z-index: 0;
      display: flex;
      transition: transform 0.5s ease;

      .top-hours-balance-card-wrapper {
        transition: 0.5s;
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        gap: 50px;
        position: relative;

        .mid-line-hours-balance {
          position: absolute;
          left: 195px;

          path {
            transition: 0.5s;
            stroke: var(--border);
          }
        }

        .hours-balance-left-box {
          color: #7E8DA7;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .hours-balance-title {
            width: 100%;
            font-size: 16px;
            font-weight: 600;
            height: 30%;
            position: relative;

            .balance-hours-tooltip {
              position: absolute;
              top: 2px;
              right: -18px;
            }
          }

          .hours-balance-content {
            max-width: 121px;
            font-size: 11px;
            font-weight: 400;
          }
        }

        .hours-balance-right-box {
          display: flex;
          align-items: center;
          color: #2ACC6B;
          text-align: center;
          font-size: 26px;
          font-weight: 500;
        }
      }
    }

    .hours-balance-card:hover {
      transform: scale(1.1)
    }

    .home-advice-wrapper {
      display: flex;
      padding: 15px;
      gap: 8px;
      position: relative;
      cursor: pointer;

      .home-advice-left-box {
        display: block;
        position: relative;

        .home-advice-type-title {
          font-size: 17px;
          font-weight: 600;
          color: #1B59F8;
          margin-bottom: 5px;
        }

        .home-advice-title-statement-content{
          transition: 0.5s;
          font-size: 12px;
          color: var(--text);
          position: absolute;
          left: -29px;
          font-weight: 600;
         }

        .home-advice-content {
          transition: 0.5s;
          font-size: 11px;
          font-weight: 400;
          color: var(--text);
          width: 30ch;
          position: absolute;
          left: -28px;
        }
      }

      .home-advice-right-box {
        font-size: 14px;
        color: var(--text);
        font-weight: 600;
        position: absolute;
        right: 20px;
        top: 36%;
      }
    }

    .home-advice-wrapper:hover {
      transform: scale(1.1)
    }
  }

  .mid-column {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 20px;

    .last-ten-days-home-card{
      z-index: 0;
      width: 344px;
      height: 573px;
      box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.07), 3px 6px 15px 0px rgba(0, 0, 0, 0.07), 11px 25px 28px 0px rgba(0, 0, 0, 0.06), 25px 57px 37px 0px rgba(0, 0, 0, 0.04), 44px 101px 44px 0px rgba(0, 0, 0, 0.01), 69px 158px 48px 0px rgba(0, 0, 0, 0.00);
      position: relative;

      .first-line-last-ten-days-home-card {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 18px;

        .left-box-first-line-last-ten-days-home-card {
          display: flex;
          align-items: center;
          width: 50%;
          color: #7E8DA7;
          font-size: 16px;
          font-weight: 600;
          margin-left: 5%;
          gap: 8px;
          position: relative;

          .last-ten-days-tooltip {
            cursor: pointer;
            position: absolute;
            right: 25px;
            z-index: 9 !important;
          }
        }

        .right-box-first-line-last-ten-days-home-card {
          transition: color 0.3s ease;
          text-decoration: none;
          color: #7E8DA7;
          font-size: 13px;
          font-weight: 600;
          width: 25%;
          margin-right: 6%;
        }

        .right-box-first-line-last-ten-days-home-card:hover {
          color: var(--activeHoverSidebar);
        }

        .bottom-border-first-line-last-ten-days-home-card {
          transition: 0.5s;
          position: absolute;
          width: 93%;
          border-bottom: 2px solid var(--border);
          top: 47px;
          right: 2.5%;
        }
      }

      .table-last-ten-days-home-card {
        width: 100%;
        margin-top: 23px;

        .table-content-last-ten-days-home-card {
          color: #7E8DA7;
          font-size: 14px;
          font-weight: 400;
          display: flex;
          justify-content: center;
          height: 100%;
          flex-direction: column;
          align-items: center;
          gap: 11px;

          .table-content-last-ten-days-home-card-full {
            width: 93%;
            gap: 14px;

            .content-line {
              transition: 0.5s;
              width: 100%;
              border-bottom: 1px solid var(--border);
              display: flex;
              align-items: center;
              gap: 14px;
              position: relative;

              .date-box-home-table {
                color: var(--text);
                font-size: 11px;
                padding: 8px 0px;
                width: 64px;

                .date-name {
                  color:var(--text);
                  font-size: 9px;
                  margin: 0;
                }
              }

              .worked-hours-home-table {
                font-size: 13px;
                color: var(--text);
                width: 38px;
              }

              .balance-hours-home-table {
                position: absolute;
                left: 162px;
              }

              .status-home-table {
                position: absolute;
                right: 5px;
                border-radius: 10px;
                width: 90px;
                height: 14px;
              }
            }

            .content-line:hover {
              cursor: pointer;
              background: rgba(27, 89, 248, .05);
            }

            .content-line:last-child {
              border-bottom: none;
            }
          }

          .table-content-last-ten-days-home-card-empty {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 40%;
            gap: 11px;
          }
        }

        .table-header-last-ten-days-home-card {
          display: flex;
          width: 100%;
          color: #939699;
          font-size: 11px;
          font-weight: 400;
          gap: 29px;
          position: relative;

          #first-col {
            margin-left: 18px;
          }

          #second-col {
            margin-left: 20px;
          }

          #third-col {
            margin-left: -5px;
          }

          #fourth-col {
            margin-left: 8px;
          }

          .bottom-border-table-header-last-ten-days-home-card {
            transition: 0.5s;
            position: absolute;
            width: 93%;
            border-bottom: 1px solid var(--border);
            top: 19px;
            right: 2.5%;
          }
        }
      }
    }

    .home-advice-wrapper {
      display: flex;
      padding: 15px;
      gap: 8px;
      position: relative;
      cursor: pointer;

      .home-advice-left-box {
        display: block;
        position: relative;

        .home-advice-type-title {
          font-size: 17px;
          font-weight: 600;
          color: #1B59F8;
          margin-bottom: 5px;
        }

        .home-advice-title-statement-content{
          transition: 0.5s;
          font-size: 12px;
          color: var(--text);
          position: absolute;
          left: -29px;
          font-weight: 600;
        }

        .home-advice-content {
          transition: 0.5s;
          font-size: 11px;
          font-weight: 400;
          color: var(--text);
          width: 30ch;
          position: absolute;
          left: -28px;
        }
      }

      .home-advice-right-box {
        font-size: 14px;
        color: var(--text);
        font-weight: 600;
        position: absolute;
        right: 20px;
        top: 36%;
      }
    }

    .home-advice-wrapper:hover {
      transform: scale(1.1)
    }
  }

  .right-column {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 20px;

    .annoucements-home-card{
      width: 344px;
      height: 573px;
      position: relative;

      .first-line-annoucements-home-card {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 18px;
        position: relative;

        .left-box-first-line-annoucements-home-card {
          display: flex;
          align-items: center;
          width: 50%;
          color: #7E8DA7;
          font-size: 16px;
          font-weight: 600;
          margin-left: 5%;
          gap: 8px;
          position: relative;
        }

        .right-box-first-line-annoucements-home-card {
          text-decoration: none;
          color: #7E8DA7;
          font-size: 13px;
          font-weight: 600;
          width: 25%;
          margin-right: 4%;
          transition: color 0.3s ease;
        }
        .right-box-first-line-annoucements-home-card:hover {
          color: var(--activeHoverSidebar)
        }

        .bottom-border-first-line-annoucements-home-card {
          transition: 0.5s;
          position: absolute;
          width: 93%;
          border-bottom: 2px solid var(--border);
          top: 27px;
          right: 2.5%;
        }
      }

      .annoucements-list-home-card {
        color: #7E8DA7;
        font-size: 14px;
        font-weight: 400;
        display: flex;
        justify-content: center;
        margin-top: 51%;
        flex-direction: column;
        align-items: center;
        gap: 11px;
      }

      .annoucements-list-home {
        margin: 0 !important;
        padding: 0 !important;
        transition: none !important;
        width: 91%;
        position: absolute;
        right: 14px;
        top: 70px;
      }
    }
  }

  .bottom-row {
    flex-wrap: wrap;
    gap: 18px 32px;
    justify-content: flex-start;
    display: flex;
    max-width: fit-content;
    flex: 1;
    max-height: 90px;



    .home-advice-wrapper {
      display: flex;
      padding: 15px;
      gap: 8px;
      position: relative;
      transition: transform 0.5s;
      cursor: pointer;

      .home-advice-left-box {
        display: block;
        position: relative;

        .home-advice-type-title {
          font-size: 17px;
          font-weight: 600;
          margin-bottom: 5px;
        }

        .home-advice-title-statement-content{
          transition: 0.5s;
          font-size: 12px;
          color: var(--text);
          position: absolute;
          left: -29px;
          font-weight: 600;
        }

        .home-advice-content {
          transition: 0.5s;
          font-size: 11px;
          font-weight: 400;
          color: var(--text);
          width: 30ch;
          position: absolute;
          left: -28px !important;
        }
      }

      .home-advice-right-box {
        color: var(--text);
        font-size: 14px;
        font-weight: 600;
        position: absolute;
        right: 20px;
        top: 36%;
      }
    }

    .home-advice-wrapper:hover {
      transform: scale(1.1)
    }
  }

  .pdi-progress-content {
    display: flex;
    padding: 24px;
    margin-left: 14px;
    margin-right: 14px;
    margin-bottom: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid var(--Primary-primary-main, #1B59F8);
    background: var(--Primary-primary-hover-outlined, #EDF2FE);
  }

  .pdi-progress-header {
    color: var(--Text-text-head, #3A424E);
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 125.303%;
  }

  .pdi-progress-percentage {
    color: var(--Primary-primary-main, #1B59F8);
    font-family: Montserrat;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 125.303%;
  }

  .pdi-progress-bar {
    width: 100%;
    height: 8px;
    background-color: #CEDCFF;
    border-radius: 4px;
    overflow: hidden;
  }

  .pdi-progress-fill {
    height: 100%;
    background-color: #1B59F8;
    transition: width 0.3s ease;
  }

  .pdi-objective-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
  }

  .objective-title-box {
    flex: 1;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    color: #3A424E;
  }

  .objective-progress-box {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .objective-progress-bar {
    flex: 1;
    height: 6px;
    background-color: #CEDCFF;
    border-radius: 3px;
    overflow: hidden;
  }

  .objective-progress-fill {
    height: 100%;
    transition: width 0.3s ease;
    border-radius: 3px;
  }

  .objective-progress-text {
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 600;
    min-width: 35px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/home/home.vue